export default {
	global: {
		habilitado: 'able',
		desabilitado: 'disabled',
		JornadaTrabalhoEFolgasProgramadas: 'Workday and Scheduled Breaks',
		relatorioAbastecimentoAnual: 'Annual Supply Report',
		relatorioPrecoMedio: 'Average Price Report',
		naoNecessarioImprimirRelprev: 'No need to print RELPREV',
		selecioneUmaMoeda: 'Select a currency',
		mudarMoeda: 'Change the currency',
		relatorioAeronave: 'Aircraft Report',
		relatorioCentroCusto: 'Cost Center Report',
		tipoEmbalagemCadastro: 'Type of packaging successfully created',
		exportacaoDados: 'Export Data',
		comprovanteAbastecimento: 'Supply Voucher',
		caminhao: 'Truck',
		volumeTotalAbastecido: 'Total Volume Supplied',
		naoFoiPossivelCadastrarUsuario: 'Unable to register User',
		fragil: 'Fragile',
		embalagemJaCadastrada: 'Package already registered',
		dac: 'DAC',
		avisoDeInicializacao: 'Start-up warning',
		naoHaDiariosDeBordo: 'There are no open log books, unsigned log books and open discrepancies',
		produto: 'Product',
		vencimento: 'Due date',
		valorTotalAbastecido: 'Total Value Supplied',
		volumeEmLitros: 'Volume in Liters',
		rastreamento: 'Tracking',
		precoMedio: 'Average Price',
		responsavelPeloVoo: 'Responsible for the flight',
		voceResponsavelPeloVoo: 'Are you responsible for the flight?',
		aeroporto: 'Airport',
		pais: 'Country',
		carregandoDadosCAMP: 'Loading CAMP data',
		salvandoGerandoRastreamento: 'Saving and generating tracking',
		ticket: 'Ticket',
		ticketCancelado: 'Canceled Ticket',
		cancelado: 'Canceled',
		adicionarFuncao: 'Add Function',
		tipoAplicacao: 'Application Type',
		selecioneUmaFuncao: 'Select a Function',
		jornadaMensal: 'Monthly Shift',
		componentes: 'Components',
		chamadoSuporte: 'Support',
		gestaoDe: 'Management',
		ensino: 'educational',
		gestao: 'Management',
		mecanicos: 'Mechanic',
		contratos: 'Contracts',
		contrato: 'Contract',
		semanas: 'Weeks',
		contratosSBH: 'SBH Contracts',
		desabilitar: 'Disable',
		habilitar: 'Enable',
		moeda: 'Currency',
		saldo: 'Balance',
		notaCadastradaSistema: 'Invoice Registered in the System',
		numeroCodigo: 'Code Number',
		numero: 'Number',
		linhaContrato: 'Contract Line',
		chaveNFE: 'Invoice Key',
		chaveDaNFE: 'Invoice Key',
		dataDaNFE: 'Invoice Date',
		planta: 'Plant',
		manutencaoAtrasada: 'Delayed Maintenance',
		contratosAbastecimentos: 'Supply Contracts',
		selecioneAbaixoALista: 'select on the list below the effort that you want to add to that invoice',
		clickAquiParaAnexar: 'Click here to attach',
		assinarTodosOsTrechos: 'Subscribe to all sections',
		habilitaCamp:
			'When you enable maintenance in the CAMP, it is necessary to give the first load in the inspections and tasks already done, doing this, it is necessary to put the start date of this load, from this day, if you have log books filled and / or update loads, the system will update the times of the aircraft and components that are connected to it.',
		assinarTrecho: 'Sign to excerpt',
		vooAssinadoPeloPiloto: 'Flight signed by the Pilot',
		vooAssinadoPeloMecanico: 'Flight signed by the Mechanic',
		vooAssinadoPeloOperador: 'Flight signed by the Operator',
		trechoAgrupadoPor: 'Excerpt grouped by',
		baixar: 'Download',
		naoTemManutencao: 'There is no maintenance',
		relatorioAbastecimento: 'Supply Report',
		gestaoAbastecimento: 'Supply Management',
		abastecimento: 'Supply',
		gerarNotas: 'Generate Notes',
		nenhumDiarioDisponivelParaAssinatura: 'No logbook available for subscription.',
		nenhumTrechoAdicionado: 'No stretch was added.',
		nenhumaMalha: 'There is no registered mesh',
		nenhumTrecho: 'No stretch.',
		nomeDoVoo: 'Flight Name',
		normas: 'Standards',
		adicionarSemana: 'Add Week',
		saida: 'Exit',
		alteradoPor: 'Modified by',
		nenhumaTripulacaoAdicionada: 'No crew members added',
		adicionarTripulante: 'ADD Crew Members',
		paraTodosOsArquivos: 'for all files',
		naoSaiaDessaTela: 'Do not leave this screen, this will interrupt the process.',
		todosOsDiariosForamAssinados: 'OK! All Log Diaries of this aircraft have been signed.',
		custo: 'Cost',
		gerar: 'Generate',
		adicionarPontos: 'Add Points',
		nenhumaInformacaoEncontrada: 'No Information Found',
		nenhumaInspecaoEncontrada: 'No inspetions were found.',
		maisInformacoes: 'More information',
		maisDias: 'more days',
		exibirTodas: 'Show All',
		noMes: 'Month',
		emAberto: 'Opened',
		tas: 'Tas',
		abastecedor: 'Supplier',
		em: 'on',
		assinadosPorMim: 'Signed by me',
		tempoVooMuitoGrande: 'Very long flight time',
		tempoVooMuitoGrande: 'Last Report Date',
		exportarJSON: 'Export JSON',
		exportar: 'Export',
		consultarNota: 'Load Invoice',
		novaNota: 'New Invoice',
		vooTrocado: 'Flight Changed',
		removeTrechoVoltaHorimetro: 'Remove strech and back the hourmeter',
		tipoUltimaIntervencao: 'Type of last inspection',
		ultimaAtualizacaoDaManutencao: 'Last maintenance update',
		atualizarCartoes: 'Update Cards',
		atualizarCartao: 'Update Card',
		tipoProximaIntervencao: 'Type of next Inspection',
		horasCelulaProximaInspecao: 'Hours Cell Next Inspection',
		responsavelPeloRetorno: 'Responsible for the Return',
		ciclosTotais: 'Total Cycles',
		ciclosTotaisManutencao: 'Total Maintenance Cycles',
		parciais: 'Partial',

		horimetroInicialCelula: 'Hm. Initial Cell',
		horimetroInicialManutencao: 'Hm. Initial Maintenance',
		horimetroFinalCelula: 'Hm. Final Cell',
		horimetroFinalManutencao: 'Hm. Final Maintenance',
		totalDePartidas: 'Total Departures',
		totalDePousos: 'Total Landings',
		totalDeGancho: 'Total Hooks',
		totalDeGuincho: 'Total Winches',
		totalDeCiclosNG: 'Total NG Cycles',
		totalDeCiclosNF: 'Total NF Cycles',
		ciclosNF: 'NF Cycles',
		ciclosNG: 'NG Cycles',
		semMaisAlertas: 'No More Alerts',
		nenhumAlertaEncontrado: 'NO ALERTS FOUND',
		pancreas: 'Pancreas',
		objetivosAlcancados: 'Objective Achieved',
		parcial: 'Partial',
		carregandoListas: 'Loading Lists',
		assinaturaDigitalPilotoComando: 'Digitally signed by the pilot in command',
		assinaturaDigitalMecanico: 'Digitally signed by mechanic',
		assinaturaDigialInspetor: 'Digitally signed by inspector',
		assinadoDigitalmentePor: 'Digitally signed by',

		nenhumMotorAcionado: 'No powered engine',
		agrupado: 'Grouped',
		gerarOrdemServico: 'Generate Work Order',
		aPartirDe: 'From',
		abaixoDe: 'Below',
		acimaDe: 'Above',
		passouTolerancia: 'Passed from tolerance',
		tolerancia: 'Max. Limit',
		emTolerancia: 'in tolerance',
		pontualOuCondicao: 'Punctual or On Condition',
		inspecaoAtiva: 'Active Inspection',
		de: 'of',
		gestaoAeronave: 'Aircraft Management',
		ateFiltro: 'to',
		concluidoPor: 'Completed by',
		quadrantes: 'Quadrants',
		calendarioManutencao: 'Maintenance Schedule',
		pressioneCtrl: 'Press Ctrl',
		limparFiltro: 'Clear Filter',
		quandoPesquisarPorLongosPeriodos: 'When search for long periods',
		oResultadoPodeDemorarUmPouco: 'the result may take a while.',
		inspecaoDesativada: 'Inspection Disabled',
		desejaEncerrarEsseDespacho: 'Do you want to close this dispatch',
		novoProcedimento: 'New Procedure',

		objetivosMissaoAlcancados: 'Have mission objectives been achieved?',
		ocorrencias: 'Occurrences',
		codigoClassificacao: 'Classification code',
		qualificacaoCivil: 'Civil qualification',
		descricaoDosFatos: 'Description of the facts',
		adicionarOcorrencia: 'Add Occurrence',
		tooltipQualificacaoCivil:
			'Best possible civil qualification of the persons involved (full name, identification document used for embarkation, nationality and date of birth, among others).',
		tooltipDescricaoFatos: 'Description of the facts, necessarily, informing what and how the occurrence occurred.',
		tooltipLocalOcorrencia:
			'Place of occurrence, necessarily, by the code of locality or geographical coordinate if in the ground and, obligatorily by geographical coordinate, if in flight.',
		discrepanciasTecnicas: 'Technical Discrepancies',
		acoesTomadas: 'Actions taken',
		inverter: 'Reverse',
		totalHorasPiloto: 'Total Hours (Pilot)',
		decimo: 'Tenth',
		galao: 'Gallon',
		litros: 'Liters',
		libras: 'Pounds',
		centroDeCustos: 'Cost Center',
		volume: 'Volume',
		valorTotalProduto: 'Total Product Value',
		valorProduto: 'Product Value',
		valorTributos: 'Value Taxes',
		valorUnitarioTributos: 'Unit Value with Taxes',

		selecionarUmDespacho: 'Select an Dispatch',
		selecionarDespacho: 'Select Dispatch',
		maisDeumDespacho: 'We found more than one dispatch for this aircraft, select which dispatch that flight refers to.',
		maisDeumItem: 'more than one item',
		nenhumDespacho: 'We did not find any dispatch for this aircraft, select one from the list or enter an dispatch.',
		nenhumaDiscrepanciaAberta: 'No open discrepancy.',
		nenhumaDisponibilidadeEncontrada: 'No avaibility was found.',
		todasDiscrepanciasConcluidas: 'All discrepancies completed',
		gerarOrdemMissao: 'Generate Mission Order',
		indisponibilizarAeronave: 'Unavailability of the aircraft?',
		selecioneInspecaoAbaixo: 'Select an inspection below',
		adicionarInspecoes: 'Add Inspections',
		adicionarInspecao: 'Add Inspection',
		salvarOrdemMissao: 'Save the work order, or go back to Due List or Manuals and enter the missing inspections',
		esseGrupoExige: 'This group requires the signature of the inspector',
		aposSelecionarInspecao:
			'After selecting all the inspections you want, click \'Add Inspections\'.',
		visualizarOrdemServico: 'View Service Order',
		todasInspecoesAssinadaPeloMecanico:
			'All inspections signed by the mechanic.',
		todasInspecoesAssinadaPeloInspetor:
			'All inspections signed by the inspector.',
		assinarMecanico: 'Mechanic\'s signature',
		assinarInspetor: 'Inspector\'s signature',
		confirmarAssinatura: 'Confirmed new signature',
		confirmarNewPassword: 'Confirmed new password',
		inspetor: 'Inspector',
		letra: 'Letter',
		descricaoServico: 'Service Description',
		dataExecucao: 'Execution Date',
		concluiEssaInspecao: 'I Concluded this Inspection',
		dataConclusao: 'Date Completed',
		disponivelParaRetorno: 'Available for Return',
		ordemDeServicoSalvaComSucesso: 'Service Order Saves Successfully',
		ordemDeServicoConcluida: 'Order of Service Completed',
		aeronaveNaoRetornouAoServico: 'The aircraft did not return to service because there is an open order',

		cancelarOrdemServico: 'Do you want to CANCEL this work order?',
		carregandoOrdemServico: 'Loading Service Order',
		cumpridoConformeDocumentacaoReferencia: 'Complying with Reference Documentation.',
		ordemServicoManutencao: 'Maintenance Service Order',
		adicionarPeloMenosUmaInspecao: 'You have to add at least one inspection.',
		excluindo: 'Deleting',
		excluida: 'Deleted',
		criarModeloPadrao: 'Create a Standard Model',
		inpecoesAssinadas: 'Signed Inspection(s).',
		processandoManutencao: 'Processing Maintenance (this may take a while)',
		processandoManutencaoVisao: 'Processing Maintenance',

		adicionarDocumentacao: 'Add Documentation',
		adicionarCarga: 'add charge',
		desejaCancelarDiscrepancia: 'want to cancel this discrepancy',
		desejaConcluirDiscrepancia: 'want to finish this discrepancy',
		cargaInicial: 'Initial Charge',
		manutencaoAeronave: 'Aircraft Maintenance',
		nenhumaDocumentacaoAdicionada: 'No Documentation Added',
		nenhumArquivoAnexado: 'No files attached',
		nenhumItemEncontrado: 'No Itens was found',
		naoCalculado: 'Uncalculated',
		semValor: 'Valueless',
		vencido: 'Expired',
		novaDocumentacao: 'New Documentation',
		ultimaData: 'Last Date',
		documentos: 'Document(s)',
		documentoS: 'Documents',
		proximo: 'Next',
		documentacaoSalva: 'Documentation Saved',
		lista: 'list',
		diagonal: 'Diagonal',
		alterar: 'Change',
		tooltipReabrirDespacho: 'Reopen Dispatch',
		encerrar: 'Close',
		cliqueNoHistoricoParaCarregar: 'Click history to upload.',
		nenhumHistoricoEncontrado: 'No historic found.',
		// RELATORIOS
		acumuladoAno: 'Accumulated Year',
		acumuladoMes: 'Accumulated Month',
		diaAnterior: 'Last day',
		voos: 'Flights',
		extrato: 'Extract',
		extratoDiarioDeBordo: 'LogBook Extract',
		selecione: 'Select',
		mediaCiclos: 'Avarage Cycles',
		selecioneUmMotor: 'Select an Engine',
		selecioneUmManual: 'Select a manual',
		gerarExcel: 'Generate Excel',
		relatorioMetaHorasVoadas: 'Goal Hours Flying Report',
		relatorioHorasVoadas: 'Flight Hours Report',
		todosOsTipos: 'All Kinds',
		efetividade: 'Effectiveness',
		servicos: 'Services',
		metaMes: 'Monthly Goal',
		metaAno: 'Annual Goal',
		indicadorAno: 'Annual Indicator',
		indicadorMes: 'Monthly Indicator',
		aeronavesAsasRotativas: 'Aircraft Rotating Handles',
		asasRotativas: 'Rotating Handles',
		aeronavesAsasFixas: 'Aircraft Fixed Wings',
		asasFixas: 'Fixed Wings',
		and: 'and',
		legislacao: 'Legislation',
		gerandoRelatorio: 'Generating Report',
		favorPreencherCamposEmVermelho: 'Please fill in the field (s) in red!',
		naoFoiPossivelGerarRelatorio: 'Report could not be generated',
		metaHoras: 'Goal Hours',
		voadas: 'Winged',
		auditoria: 'Audit',
		relatorioAlocacao: 'Allocation report',
		relatorio: 'Report',

		relatorioIndicadorEfetividade: 'Effectiveness Indicator Report',
		resultadosObtidos: 'Results Obtained',
		meta: 'Goal',
		varIndMeta: 'var % ind/tar',
		acumulado: 'Accumulated',
		mesAtual: 'Current month',
		relatorioHorasDeVoo: 'Flight Hours Report',
		exibicao: 'Display',
		nomeCompleto: 'Full Name',
		horimetroInicialMotor: 'Engine Starter Horimeter',
		horimetroFinalMotor: 'Final Engine Horimeter',
		instrutor: 'Instructor',
		instalacao: 'Installation',
		fabricacao: 'manufacturing',
		indicador: 'Indicator',
		servico: 'Service',
		horasDeVooApoio: 'Flight Hours in Support',
		relatorioPrestacaoDeContas: 'Reporting of Accounts TDCO',
		aeronavesOperadasPelo: 'Aircraft Operated by',
		auditoriaDiarioDeBordo: 'Daily Onboard Audit',
		processarAuditoria: 'Process Audit',
		verificados: 'Verified',
		verificar: 'Check',
		verificarDisponibilidades: 'Check Availability',
		trocarVoo: 'Change flight',
		trocar: 'Change',
		dataProcessamento: 'Data Processing',
		altitudeRecuperadaAtraves: 'Altitude recovered through Google Maps',
		ausentes: 'Absent',
		corrompidos: 'Corrupted',
		adicionarAplicabilidade: 'Add applicability',
		aplicabilidade: 'applicability',
		nomeAlternativo: 'Alternative Name',
		intercambialidade: 'Interchangeability',
		validos: 'Valid',
		validando: 'Validating',
		arquivosAusentesCorrompidos: 'Missing / Corrupted Files',
		numeroDiario: 'Daily Number',
		vooReferenteAData: 'Flight Related to Date',
		daAeronve: 'aircraft',
		daAeronve: 'Graphics',
		arquivo: 'File',
		registro: 'Record',
		relatorioOVN: 'Report NVG',
		perfilTripulacao: 'Profile Crew',
		id: 'id',
		perfilTipo: 'Profile Type',
		tipoTarefa: 'Task Type',
		cor: 'Color',
		emMovimento: 'In Movement',
		todasAsFuncoes: 'All Functions',
		horasVooTripulacao: 'Flight Hours Crew',
		acumuladoNoPeriodo: 'Accumulated in the Period',
		experienciaRecente: 'Recent Experience - Last 90 days',
		horasVoo: 'Hours of Flight',
		ultimoVoo: 'Last Flight',
		satelite: 'Satellite',

		// submenu Adm Geral
		cadastroDeDocumentacao: 'Documentation Registration',
		cadastroPontosInteresse: 'Points of Interest Register',
		cadastroTipoEmbalagem: 'Package Type Register',
		planoDeFundo: 'Wallpaper Home Screen',
		gerenciamentoVoo: 'Flight Management',
		logProcessamento: 'Registry Log',
		configBackend: 'Backend Configuration',
		dadosDoCliente: 'Client\'s Data',
		cadastroAtividade: 'Activity Log',
		metaIndicadores: 'Goal and Indicators',
		pontos: 'Markers',

		// Cadastro Usuario
		novoSimplificado: 'New Simplified',
		listarNovosUsuarios: 'List New Users',
		usuariosDesativados: 'Disabled Users',
		usuarioDesativado: 'Disabled User',
		cadastroUsuarioSimplificado: 'Simplified User Registration',
		editarUsuarioSimplificado: 'Edit Simplified User',
		cpfUsadoComoLoginEsenha: 'The ID number will be used as LOGIN and PASSWORD, which must be changed on the first access.',
		senhasNaoCoincidem: 'The password typed does not match',
		senhaUtilizadaAoLogar: 'Password used to login to the system',
		ativarUsuario: 'Enable User',
		desejaAtivarEsseUsuario: 'Do you want to enable this User?',
		desejaDesativarEsseUsuario: 'Do you want to disable this User?',
		desativarUsuario: 'Disable User',
		emBrancoMantemAssinatura: 'In blank, keep the same signature',
		alterarAssinaturaNoProximoLogin: 'Change Signature on next login?',
		hAssinatura: 'Signature',

		// Perfil
		carregaAutomaticoPerfilAoCriarUsuario: 'Automatically load this profile when creating a new user?',
		diarioDeBordoMecanico: 'Mechanical Logbook',
		cartaDeSituacaoOperacoes: 'Status Chart Operations',
		diarioDeBordoOperador: 'Daily Logger Operator',

		// Prevenção Qualificada
		horariosMaisComuns: 'Most common times',
		dadosDaPrevencao: 'Prevention Data',
		minutos: 'Minutes',
		voltarMapa: 'back to map',
		zqc: 'HZD',
		zonaQuenteCriminalidade: 'Hot Zone of Danger',
		desejaCancelarPrevencao: 'Do you want to CANCEL this prevention?',
		desejaCancelarTicket: 'Do you want to CANCEL this Ticket?',

		contatosMissao: 'Mission Contacts',
		novoContato: 'New Contact',
		discrepancia: 'discrepancy',
		comandanteLocalMissao: 'Mission Commander on-site',

		selecioneUmaAero: 'Select an aircraft to begin with.',
		posicoes: 'Positions',
		cadastroUnidadeConservacao: 'Conservation Unit Registration',
		municipio: 'City',
		areaMapeamento: 'Mapping Area',
		areaMonitoramento: 'Monitoring Area',
		areaCriacao: 'Creation Area',
		esfera: 'Sphere',
		operador: 'Operator',
		eOperador: 'is the operator',
		operadorIndefido: 'The operator has not been defined',
		manutencaoNaoDeuParecer: 'Maintenance did not give an opinion',
		manutencaoDeuParecer: 'Has the opinion of the maintenance',
		naoTemParecerManutencao: 'Do not have the opinion of maintenance',
		operacoesNaoDeuParecer: 'The operations did not give the opinion',
		operacoesDeuParecer: 'Has the opinion of the operations',
		naoTemParecerOperacoes: 'Do not have the opinion of the operations',
		naoDefinido: 'Undefined',
		aprovado: 'Approved',
		naoAprovado: 'Not approved',
		inseridoPor: 'Inserted by:',
		finalizadoPor: 'Finalized by:',
		finalizadoPor: 'Finished',
		emExecucao: 'Running',
		emAnalise: 'In analysis',
		preenchimentoConcluido: 'Completed',
		indeterminada: 'Undetermined',
		semSolicitacao: 'No request',

		administrativa: 'Administrative',
		termino: 'Conclusion',
		terminoOrdem: 'End of the Order',
		temUmTermino: 'There is a term',
		apareceraDespachoAeronaves:
			'Will it appear in the Aircraft Dispatch until the option \'Close this dispatch?\' be marked as YES.',
		dataTermino: 'End Date',
		dataDiario: 'Daily Date',
		situacao: 'Situation',
		naoHaEmpregoAeronave: 'There is no aircraft employment',
		determinacaoSessaoManutencao: 'As determined by the maintenance session',
		aeronaveTurnoServico: 'work shift aircraft',
		adicionarBase: 'Add Base',
		semPassageiros: 'No passengers',
		naoHaCarga: 'No charge',
		naoHaRoteiro: 'There is no script',

		despacho: 'Dispatch',
		tipoDespacho: 'Type of Dispatch',

		dataAbertura: 'Opening data',
		dataAberturaCadastro: 'Date',
		instrutorVoo: 'flight instructor',
		segundoComando: 'Second in command',
		obrigPilotoComando: 'Mandatory for pilot in command',
		obrigInstrutorVoo: 'Required for flight instructor',

		solicitaUsoAeronave: 'Request for aircraft use',
		horimetroInicial: 'Hm. Initial',
		vooInicial: 'Initial flight hours',
		ciclosTotaisMotor: 'Total Engine Cycles',
		horimetroFinal: 'Hm. Final',
		vooFinal: 'Final Flight Hours',
		aval: 'Checks',

		adendo: 'addendum',
		dataHoraCadastro: 'Date-Time Registration',
		tipoMapa: 'Type Map',
		ativo: 'Active',
		fechado: 'Closed',
		mapa: 'Map',
		boletins: 'SB',
		maintenanceStatus: 'Maintenance Status',

		gerarPrevencao: 'Generate Prevention',
		despachoAeronaves: 'Aircraft Dispatch',
		demandaReprimida: 'Pent-up Demand',
		motivacao: 'Motivation',
		semVitimas: 'No Victims',
		codinome: 'Codename',
		selecioneOrdemMissaoAbaixo: 'Select the order the mission below.',
		exibirEncerradas: 'Display closed',
		exibirFaturaEmAtraso: 'Display message "Invoice overdue"?',
		alinhaTabela: 'To Align Table',
		solicitacaoInserida: 'Request entered in the system.',
		dadosDaMissaoPreenchidos: 'All the data in the mission order has been filled, it is waiting for execution.',
		processoEmAndamento: 'Ongoing process of a mission or dispatch order.',
		dataAtualMaiorUltimoTrecho: 'The current date is greater than the last portion of the mission order.',
		dataAtualizacao: 'Update date',
		cadastrarProcedimento: 'Procedure Register',
		cadastrar: 'Register',
		excluirProcedimento: 'Delete Procedure',
		todosProcessosOrdemMissaoOuDespachoConcluidos: 'All the processes of the order of mission or dispatch have been completed.',

		nenhumaSolicitacaoParaEssesDias: 'No Request for these days',
		nenhumaOrdemParaEssesDias: 'No Order for these days',
		nenhumDespachoParaEssesDias: 'No dispatch for those days',
		emExecucaoOuAberta: 'Running or open',
		emExecucaoVencida: 'In overdue execution',
		tarefas: 'Tasks',
		exibirConcluidos: 'View Completed',
		esconderConcluidos: 'Hide Completed',
		concluidos: 'Concluded',
		enterSalvaEscCancela: 'ENTER to save and ESC to cancel',
		ate: 'until',
		ajustes: 'SETTINGS',
		despachos: 'Dispatchs',
		despachoSalvo: 'Dispatchs Saved',
		contexto: 'Context',
		Por: 'Per',
		por1: 'by',
		entrada: 'Entry',
		aplicar: 'Apply',
		mensagem: 'Message',
		mensagemFaturaAberta: 'This is a reminder that your invoice is open. Make the payment to avoid instability in the FollowAir system. If in doubt, contact the financial sector. If payment has already been made, please disregard this message',
		nenhumaConversaEncontrada: 'No conversations found.',
		nenhumaAeronaveAdicionada: 'No aircraft added',
		excluirFatura: 'Delete Invoices',
		excluir: 'Delete',
		prefixoAeronave: 'Aircraft Tail Number',
		faturaEmAberto: 'APERTURE INVOICE',
		faturaFechadaPor: 'INVOICE CLOSED BY',
		faturaSBH: 'SBH Invoice',
		serialNumberMotor: 'Serial Number Engines',
		enviar: 'Send',
		assinaturaMotivo: 'Reason sent successfully!',
		vocePodeAtualizar: 'You can now update the logbook',
		voce: 'You',
		semMaisConversa: 'No more talking.',
		todosOsTrechos: 'All Strechs',
		todosOsVoos: 'All Flights',
		souPiloto: 'I\'m a pilot',
		piloto: 'Pilot',
		de: 'Of',
		assinadoPor: 'Signed by',
		assinadosPorMim: 'Signed by me',
		cliqueTrechoCarregar: 'Click the snippet to load it.',
		diario: 'Daily',
		tempoTotalPiloto: 'Total Pilot Time:',
		anac: 'FAA',
		naoHaDiscrepancia: 'There are no discrepancies',
		despachoDeAeronaves: 'Aircraft Dispatch',
		acoes: 'Actions',
		autoLocalizacao: 'Auto Location',
		voo: 'Flight',
		armasApreendidas: 'Weapons Seized',
		pessoasDetidas: 'Detained Persons',
		pessoasSalvas: 'People Saved',
		valorRecuperado: 'Recovered Value',
		bambiBucket: 'Bambi Bucket',
		adicionarDespacho: 'Add dispatch',
		alterarDespacho: 'Change Dispatch',
		ressalvas: 'Reservations',
		nenhumaRessalvaAdicionada: 'No Added Caveat',
		nenhumArquivo: 'No files attached',
		adicionarRessalva: 'Add caveat',
		tempoSobrevoo: 'Overflight Time',
		desejaExcluirEsseDespacho: 'Do you want to delete this dispatch?',
		desejaExcluirEsseProcedure: 'Do you want to delete this procedure?',
		desejaExcluirEmbalagem: 'Do you wish to exclude this Packaging?',
		embalagemExcluidaComSucesso: 'Pagackage sucessfully deleted',
		helicopteros: 'Helicopters',
		seguro: 'Insurance',
		disponivel: 'Available',
		indisponivel: 'Not Available',
		atividadesAereas: 'Air Activities',
		relatorioPerfil: 'Profile Report',
		eUsuario: 'and User',
		relatorioDiarios: 'Daily Reports',
		naoAssinados: 'Unsigned',
		semTermoAbertura: 'No opening term',
		atividadesAereasGeral: 'General Air Activities',
		ordemMissaoPrevencaoQualificada: 'Order of Mission of Qualified Prevention',
		selecioneOrdemMissaoPrevencaoQualificada: 'Select a qualified prevention mission order',
		selecioneOrdemMissaoPrevencaoAbaixo: 'Select the qualified prevention mission order below.',
		ativa: 'Active',
		preventiva: 'Preventive',
		copiloto: 'Copilot',
		pilotoInstrucao: 'Pilot in Instruction',
		pilotoComando: 'Pilot in Command',
		operadorAerotatico: 'Air Operator',
		estagiario: 'Intern',
		canceladaComSucesso: 'Successfully Canceled',
		prevencaoQualificada: 'Qualified Prevention',
		prevencaoSalva: 'Prevention Saves',
		numeroPrevencao: 'Number of Prevention',
		despachoExcluido: 'Excluded Order',
		tempo: 'Time',
		reabrirDespacho: 'Do you want to reopen this Office?',
		despachoReaberto: 'Office Reopened.',
		reabrindo: 'Reopening',
		entregar: 'Give',
		cancelarDespacho: 'Cancel Office',
		tudoCerto: 'All right, the applicant can now receive the item(s)!',
		carregandoDiarios: 'Loading daily',
		carregandoComponentes: 'Loading components',
		necessarioPeloMenosUmaInspecao: 'At least one inspection required to update',
		chegada: 'Arrival',
		ordensDeMissao: 'Mission Orders',
		documentacao: 'Documentation',
		ordemDeServico: 'Work orders',
		horasVoadasAbreviacao: 'HF',
		desativarInspecao: 'Disable Inspection',
		ativarInspecao: 'Enable Inspection',
		refOrigem: 'Ref Origin',
		ativar: 'To Activate',
		desativar: 'Disable',
		para: 'for',
		justificativaInspecao: 'this inspection need a justification',
		tituloTarefa: 'Task Title',
		numeroTarefa: 'Task Number',
		numeroPeca: 'Part Number',
		irParaOrdemServico: 'Go to the Work order',
		intervaloServico: 'Service Interval',
		ultimoServico: 'Last Service',
		abertura: 'Opening',
		relatorioPerfilUsuario: 'Profile and user report',
		diariosDeBordoNaoAssinados: 'Non-signed Logbooks',
		numeroDB: '*LB Number',
		novoKit: 'New Kit',
		kitComissaria: 'Commissioner Kit',
		comissario: 'Commisioner',
		quantosItens: 'How Many Items?',
		dadosKit: 'Kit Data',
		quantidade: 'Amount',
		dataEstimada: 'Estimated Due',
		itens: 'Itens',
		suprimento: 'Supply',
		quantidadeDeDias: 'Number of Days',
		cadastroAplicabilidade: 'APPLICABILITY REGISTER',
		unidadeDeMedida: 'Unit of measure',
		unidadeDoOrgao: 'Organ Unit',
		irParaA: 'go to',
		ocorreuErroTenteNovamente: 'An error has occurred, please try again',
		deveConterMininoUm: 'Must contain at least 01',
		oKitDeveConterUmItem: 'The kit must contain at least 01 item',
		cadastroFornecedor: 'Supplier Registration',
		novoFornecedor: 'New Supplier',
		fornecedores: 'Suppliers',
		razaoSocial: 'Company Name',
		nomeContato: 'Contact Name',
		nomeDaUnidade: 'Unit Name',
		desejaExcluirFornecedor: 'Do you want to delete this provider?',
		fornecedor: 'Provider',
		dadosFornecedor: 'Supplier Data',
		numeroIdentificacaoEmpregado: 'Employer Identification Number',
		valoresPorOrgao: 'Values by Agencies',
		cnpj: 'CNPJ',

		termoDeUso: 'Terms of use',
		cadastroDeBase: 'Base Registration',
		controleInpencoesComponentes: 'Control of Inspections and Components',
		escola: 'School',
		ola: 'Hello',
		gestaoInterna: 'Internal Management',
		baseOperacional: 'Operational Base',
		forcarAssinarTermo: 'Force sign term?',
		salvarTermo: 'Save Term',
		termoAtualizado: 'Updated Term',
		termoAbertura: 'Opening Term',
		graus: 'Degrees',
		decimal: 'Decimal',
		vooRegular: 'Regular Flight',
		snCelula: 'SN CELL',
		carregarModelo: 'Upload Template',
		nomeModelo: 'Model',
		regNo: 'RegNo',
		atualizandoModelosAeronaves: 'Updating aircraft models',
		atualizando: 'Updating',
		modelosAtualizados: 'Updated Templates',
		novaCategoria: 'New Category',
		exibirDesativados: 'Display disabled',
		editarCategoria: 'Edit Category',
		exibirLegendas: 'View Captions',
		editarCapitulo: 'Edit Chapter',
		novoCapitulo: 'New Chapter',
		capitulo: 'Chapter',
		carregandoModelo: 'Loading Template',
		componentes: 'Components',
		// termino

		cadComissaria: 'Commissioner registration',
		numReds: 'No. REDS',
		numChamada: 'No. Call',
		numAtividade: 'No. activity',
		subEclassificacao: 'Subclassification and Classification',
		descricaoDaMissao: 'Description of the Mission',
		idadeAparente: 'Idade Aparente',
		sexo: 'Genre',
		vitimas: 'Victims',
		usoDeFlir: 'Use of FLIR',
		usoDeOvn: 'Use of OVN',
		ordemEncerrada: 'Order closed',
		origemDoVoo: 'Flight origin',
		tripulacao: 'Crew Members',
		cadTripulacao: 'Crew Registration',
		proa: 'Bow',
		combustivel: 'Fuel',
		combustivelInicial: 'Initial Fuel',
		combustivelConsumido: 'Consumed Fuel',
		combustivelTotal: 'Total Fuel',
		digiteSeuLogin: 'Enter your login.',
		irParaO: 'GO TO',
		selecioneUmaCor: 'Pick a Color',
		textoSenhaAlteradaSucesso: 'Your password has been changed successfully!',
		textoModificarSenha: 'To change your current password, type the new password in the field below.',
		naoFoiPossivelEncontrarDados: 'No data was found by this login.',
		comUmLink: 'with a link to retrieve your password!',
		enviamosUmEmail: 'We send you email',
		avancar: 'Next',
		textoDigiteSeuLogin: 'Enter your login and we will find the best way to set a new password.',
		esqueceuSuaSenha: 'Forgot your password?',
		esqueciMinhaSenha: 'I forgot my password',
		carregarFoto: 'Upload Photo',
		disponivelNa: 'Available in',
		excluirFoto: 'Delete Photo',
		carrgandoFoto: 'Loading photo',
		clickExibirApp: 'Click here to access the Followair of your phone.',
		leiaQRCode: 'Read the QR Code through Followair on your phone.',
		acessarApp: 'Access App',
		departamento: 'Department',
		cadastroDeDepartamento: 'Department Registration',
		sessao: 'Session',
		secao: 'Section',
		cadastroDeSessao: 'Session Registration',
		cadastroDeSecao: 'Section Registration',
		numeroCarne: 'Number of Meat',
		desejaExcluirEssaSolicitacao: 'Do you want to delete this request?',
		excluidoComSucesso: 'Deleted successfully.',
		todos: 'All',
		oUsuarioPodeAlterarSuasConfigs: 'Can you edit your settings?',
		carregandoManutencoes: 'Loading Maintenance',
		conjuge: 'Spouse',
		licenca: 'License',
		numero: 'Number',
		voceJaAddItem: 'You have already added this item.',
		exercicios: 'Exercises',
		novaDisciplina: 'New Discipline',
		disciplina: 'Discipline',
		emHoras: 'In hours',
		disciplinaAtualizada: 'Updated course',
		disciplinaInserida: 'Discipline inserted',
		tipoDeVoo: 'Type of flight',
		solo: 'Ground',
		dc: 'dc',
		duracao: 'Duration',
		descricaoDoExercicio: 'Exercise Description',
		descricaoDoTema: 'Theme Description',
		nivelDeAprendizagem: 'Level of Learning',
		alterarSenha: 'Change the password',
		porQuestoesAlterarSenha: 'For security reasons it is necessary for you to change your password.',
		digiteNovaSenhaAbaixo: 'Enter the new password in the field below.',
		novaSenha: 'New password',
		voceNovaSenha: 'You have to enter the new password.',
		alterandoSenha: 'Changing your password',
		naoFoiPossivelAlterarSenha: 'Could not change password.',
		atualizacao: 'Update',
		atualizacoes: 'Updates',
		centralizar: 'Centralize',
		sessaoExpirada: 'Session expired',
		secaoExpirada: 'Section expired',
		algoDeuErrado: 'Something went wrong!',
		aconteceuUmProbleminha: 'There was a problem trying to make this request, but calm down!',
		seOErroPersistir: 'If this error persists please contact our support.',
		regulamento: 'Regulation',
		parametrosLegais: 'Legal Parameters',
		situacaoTripulacao: 'Crew Situation',
		jornadaTrabalho: 'Workday',
		jornadaTrabalhoCumprida: 'Workday Accomplished',
		cargaHorariaSemanal: 'Weekly Workload',
		jornadaDeTrabalho: 'Work Day',
		tipoAeronave: 'Aircraft Type',
		leiAeronaura: 'Aeronaut Law',
		lei: 'Law',
		aeronauta: 'Aeronaut',
		numeroLei: 'Law Number',
		regulamentoAtualizado: 'Regulation updated',
		regulamentoSalvo: 'Regulation saved',
		suaSessaoExpirou: 'Your session has expired.',
		suaSecaoExpirou: 'Your section has expired.',
		aeronaveAplicavel: 'Applicable Aircraft',
		limiteReferencia: 'Reference Limit',
		novoParametro: 'New Parameters',
		digiteSuaSenhaParaRenovala: 'Enter your password to renew it.',
		vcTemQueDigitarSenha: 'You have to enter your password.',
		sessaoAtualizada: 'Updated session',
		secaoAtualizada: 'Updated section',
		senhaInvalida: 'Invalid password.',
		nenhumDadoEncontrado: 'No data found for this date.',
		matriculado: 'Registered',
		pendentePagamento: 'Pending Payment',
		dataNascimento: 'Birthday',
		estadoCivil: 'Civil Status',
		solteiro: 'Single',
		casado: 'Married',
		divorciado: 'Divorced',
		viuvo: 'Widower',
		separado: 'separated',
		nacionalidade: 'Nationality',
		naturalidade: 'naturalness',
		atualizado: 'Updated',
		atualizar: 'Update',
		atualizarItem: 'Update Item',
		atualizarGrupo: 'Update Group',
		manutencoes: 'Maintenances',
		visaoGeral: 'Show All',
		controleHorasEMotor: 'TIME CONTROL AND ENGINE CYCLES',
		controle: 'Controller',
		patrimonial: 'Equity',
		patrimonio: 'Heritage',
		perfis: 'Profiles',
		voo: 'Flight',
		registroHFDM: 'FDM',
		dadosDoVoo: 'Flight Data',
		dadosDoContrato: 'Contract Data',
		medicao: 'Measurement',
		medico: 'Medic',
		enfermeiro: 'Nurse',
		instrumentos: 'Tools',
		escolhaUmaOpcaoAoLado: 'Choose an option from the menu next.',
		sejaBemVindo: 'Seja bem-vindo ao',
		naoInformado: 'Uninformed',
		informacaovoo: 'Flight Information',
		informacaoDoPonto: 'Point Information',
		infoOrdemDeMissao: 'Mission Order Information',
		ordemDeMissao: 'Order of Mission',
		apoiados: 'Supported',
		orgaos: 'Agencies',
		programacaoVoo: 'Flight Schedule',
		atividades: 'Activities',
		operacao: 'Operation',
		local: 'Place',
		velocidade: 'Speed',
		altitude: 'Altitude',
		solo: 'Ground',
		nenhumaAlteracao: 'No changes made to the diary will be saved, for this you have to click on edit log',
		todasAlteracoesSalvas: 'All changes will be save',
		editarDiario: 'Edit Log',
		cancelarDiario: 'Cancel Edit',
		assinaturaOrdem: 'Order Mission signature',
		essaOrdemPossui: 'This order HAS signature',
		essaOrdemNaoPossui: 'This order DOES NOT HAVE signature',
		altitudeVelocidade: 'Altitude and Speed',
		graficos: 'Graphics',
		lat: 'lat',
		lng: 'lng',
		direcao: 'Direction',
		emMesesDias: 'in Months and Days',
		deTrabalho: 'Work',
		revalidacao: 'Revalidation',
		renovacao: 'Renovation',
		ultima: 'Last',
		ativarTodas: 'Activate All',
		desativarTodas: 'Deactivate all',
		notasAtualizacao: 'Update Notes',
		abaixoMudancas: 'Below as changes made in this update',
		inspecoesMandatorias: 'Mandatory Inspections',
		inspecoesNaoMandatorias: 'NON-Mandatory Inspections',
		voceAlterandoModelos: 'You are changing all models',
		voceAlterandoSerial: 'You are changing the serial number model',
		voceAlterandoAeronave: 'You are changing the aircraft model',
		todosModelos: 'All models',
		emMeses: 'In Months',
		intervalo: 'Interval',
		previsaoDeData: 'Date Forecast',
		mesesDias: 'Months and Days',
		oficina: 'Manufactory',
		horasTotais: 'Total Hours',
		horasVoadas: 'Flight Hours',
		nivel: 'Level',
		calendaricas: 'Calendars',
		calendarica: 'Calendar',
		porHoraVoada: 'By Flying Hour',
		homeHora: 'Man/Hour',
		trabalho: 'Job',
		ultimaManutencaoRealizada: 'Last maintenance done',
		proximaInspecao: 'Next Inspection',
		descricao: 'Description',
		descricaoAnp: 'Description ANP',
		escolherItemAcima: 'You have to choose one or more items above.',
		obrig: 'Required',
		variacoes: 'Variations',
		escritorio: 'Office',
		equipe: 'Team',
		estado: 'State',
		usuario: 'User',
		todasNturezas: 'All Natures',
		tempoTotal: 'Total Time',
		todas: 'All',
		contador: 'count',
		margem: 'margin',
		adicionarPeriodicidade: 'ADD FREQUENCY',
		programacao: 'Programming',
		programacaoDeVoo: 'Flight Programming',
		referenciaManual: 'Manual Reference',
		disponibilidade: 'Availability',
		previsao: 'Forecast',
		manutencao: 'Maintenance',
		manutencaoCamp: 'CAMP Maintenance',
		ciclos: 'Cycles',
		cicloDeTorque: 'Cycle Torque',
		guarnicao: 'Garrison',
		telaCheia: 'Full Screen',
		sairTelaCheia: 'Close Full Screen',
		posicao: 'Position',
		hora: 'Time',
		aeronave: 'Aircraft',
		carregandoDados: 'Loading data',
		anexo: 'Attachment',
		bairro: 'Neighborhood',
		usuarios: 'Users',
		trecho: 'Excerpt',
		total: 'Total',
		buscar: 'Type to search on the list below',
		buscarFatura: 'Search',

		adicionarEmpenhos: 'ADD Efforts',
		selecioneUmaFatura: 'Select an invoice',
		novo: 'New',
		nova: 'New',
		cliqueParaRemover: 'Click to remove',
		imprimir: 'Print',
		excluir: 'Delete',
		criar: 'Add',
		adicionarGrupo: 'Add Group',
		voltar: 'Back',
		salvar: 'Save',
		gerarRelatorio: 'Generate report',
		carregar: 'Load',
		sair: 'Exit',
		fechar: 'Close',
		concluir: 'Complete',
		visualizar: 'View',
		telefone: 'Telephone',
		aceleracao: 'acceleration',
		decolagem: 'Take-off',
		adicionarDias: 'Add days',
		adicionarMalhas: 'Add mashes',
		pouso: 'Landing',
		totalDia: 'Total on day',
		dataInicio: 'Start date',
		dataFim: 'End date',
		data: 'Date',
		ou: 'Or',
		ano: 'Year',
		mes: 'Month',
		status: 'Status',
		prioridade: 'Priority',
		codigo: 'Code',
		solicitante: 'Name',
		solicitanteSelecionado: 'This user will only be saved as an applicant in system profiles.',
		gerarOrdem: 'Generate order',
		editar: 'Edit',
		alterarStatus: 'Change status',
		cidade: 'City',
		obrigatorio: 'Fields with * are obligatory',
		campoObrigatorio: 'This field is required.',
		paraAddObrigatorio: 'To \'New\' this field is required.',
		solicitado: 'Requested',
		solicitadoEm: 'Requested On',
		desejaGerarFatura: 'Do you want to generate an invoice for that invoice',
		motivoReassinatura: 'reason for resignation',
		lotacao: 'Sector',
		tamanho: 'Scale',
		email: 'E-mail',
		inicio: 'Start',
		fim: 'End',
		retrair: 'Retract',
		perfil: 'Profile',
		relatorioPrevencao: 'Safety Report',
		titulo: 'To generate the report, fill the fields below',
		aOS: 'the WO',
		adicionado: 'Added',
		todasInspecoesDesabilitadas: 'All inpections disabled',
		todasInspecoes: 'All inspections',
		inspecaoVinculada: 'linked inspection',
		cadastro: 'Register',
		solicitacao: 'Request',
		cancelar: 'Cancel',
		carregando: 'Loading',
		enviando: 'Sending',
		obs: 'Note',
		salvando: 'Saving',
		excluindo: 'Excluding',
		escolha: 'Choose',
		escolhaOpcaoAbaixo: 'Choose an action below',
		estoque: 'Stock',
		excluirUsuario: 'Excluding user',
		ola: 'Hello',
		filtro: 'Filter',
		dataReportada: 'Reported Date',
		valorReportado: 'Reported Value',
		nenhumDiarioDeBordoEncontrado: 'NO LOGBOARD FOUND IN THIS PERIOD',
		voando: 'Flying',
		ultimo: 'Last',
		evento: 'Event',
		info: 'Information',
		equipamentos: 'Equipments',
		equipamento: 'Equipment',
		grupos: 'Groups',
		todosGrupos: 'All Groups',
		naturezas: 'Natures',
		todasNaturezas: 'All Natures',
		filtrar: 'Filter',
		exibir: 'Show',
		tipo: 'Type',
		tipoCiclo: 'Cycle Type',
		acaoAdotada: 'Adopted Action',
		horimetroCelula: 'Airframe Hourmeter',
		horimetroMotor: 'Engine Hourmeter',
		excluirAtualizacao: 'Delete Update',
		tipoEntrada: 'Entry Type',
		osDeSaida: 'Outgoing WO',
		desejaExcluirEsseItem: 'Do you want to delete this item',
		desejaExcluirEsse:'Do you want to delete this',
		tipoDeEntrada: 'Incoming Type',
		valorReferenteAData: 'Amount referring to the inspection date',
		inspecaoListadas: 'The inspections listed do not contain components linked to the same',
		natureza: 'Nature',
		dataDeInspecao: 'Inspection Date',
		grupo: 'Group',
		dias: 'days',
		Dias: 'Days',
		meses: 'Months',
		anos: 'Years',
		horas: 'Hours',
		dataManutencao: 'Maintenance Date',
		totalHorasVoadas: 'Total Hours Flown',
		totalCiclosVoados: 'Total winged cycles',
		privilegio: 'Privilege',
		configuracao: 'Settings',
		configuracaoAeronave: 'Settings Airplan',
		configuracoesEscala: 'Scale Settings',
		cadastroCombustiveis: 'Fuel Registration',

		nome: 'Name',
		nomeAdicionado: 'Added name',
		responsavel: 'Responsible',
		copiarPessoas: 'Copy people',
		conclusao: 'Conclusion',
		aberta: 'Open',
		concluida: 'Completed',
		cancelada: 'Canceled',
		cancelados: 'Canceled',
		fem: 'Female',
		masc: 'Male',
		end: 'Address',
		remover: 'Remove',
		nenhumaEscalaEncontrada: 'No scale was found',
		sim: 'Yes',
		malhas: 'Meshes',
		malha: 'Meshe',
		semana: 'Wekeend',
		filtroPor: 'Filter by:',
		voosEspeciais: 'Special Flights',
		identificacaoVoo: 'Flight Identification',
		naoHaNenhumVoo: 'THERE ARE NO SPECIAL FLIGHTS REGISTERED',
		adicionarVooEspecial: 'Add special Flight',
		nao: 'No',
		modulo: 'Choose the module you want to access',
		matricula: 'Registration',
		periodicidade: 'Interval',
		inscricao: 'Inscription',
		curso: 'Course',
		categoria: 'Category',
		nomeDaCategoria: 'Category Name',
		revisao: 'Review',
		revisaoData: 'Revision Date',
		coluna: 'Column',
		validade: 'Shelf life',
		habilitacao: 'Habilitation',
		observacao: 'Note',
		nenhumaObservacao: 'No notes added',
		novaObservacao: 'New note',
		aluno: 'Student',
		pacote: 'Package',
		valor: 'Value',
		valorReal: 'Brazilian Real',
		alterarQuantidade: 'Change Quantity',
		quantidadeAlterada: 'Quantity Changed',
		custoHora: 'Hourly cost',
		cotacao: 'Quotation',
		dataCotacao: 'Quotation date',
		inicioDoMesReferencia: 'Start of the Reference Month',
		horasECiclosDoMes: 'HOURS AND CYCLES OF THE MONTH',
		consumoDeCiclos: 'CYCLE CONSUMPTION',
		desdeOInicio: 'since the beginning of the operation in the month',
		inicioSBH: 'Start SBH',
		custoDoCiclo: 'Cycle cost',
		parcela: 'Portion',
		maximo: 'Maximum',
		parcelas: 'Plots',
		adicionar: 'Add',
		forma: 'Payment',
		em: 'In',
		totalPago: 'Total Paid',
		formaDePagamento: 'Form of payment',
		faltaPagar: 'Still have to pay',
		msgPagamentoMaiorPagamento: 'You are adding a larger amount than the purchase.',
		administracaoEscolar: 'School Administration',
		selecioneParaExibir: 'Select an item to open the settings.',
		escolaDeVoo: 'School of Flight',
		valordaMatricula: 'registration fee',
		valorCursoTeorico: 'theoretical course value',
		valorHoraCursoPrático: 'value practical course',
		fabricante: 'Fabricator',
		orgao: 'Agency',
		velocidadeMedia: 'Average speed',
		consumo: 'Consumption',
		tanque: 'Tank',
		escolhaoAluno: 'Choose the Student',
		escolhaoCurso: 'Choose Course',
		carregar: 'Load',
		comoDesejaFiltar: 'Choose form you\'d like to filter',
		fechaExercicio: 'CLOSE EXERCISE',
		exercicio: 'EXERCISE',
		nomeESobrenomealuno: 'NAME AND LAST NAME',
		planoDeRegistro: 'AIRPLANE',
		instruçãoDemissao: 'MISSION INSTRUCTION',
		desembarque: 'N°LANDING',
		tempoDeVoo: 'Flight time',
		produto: 'Product',
		avaliacaoGeral: 'GENERAL EVALUATION',
		nomeESobrenomeinstrutor: 'NAME AND SURNAME OF THE INSTRUCTOR',
		grau: 'GRADE',
		assinatura: 'Signature',
		naoSatisfeito: 'NOT SATISFIED',
		regular: 'REGULAR',
		excelente: 'EXCELLENT',
		nice: 'GOOD',
		registroNome: 'REGISTRATION - NAME',
		materiaEncerrada: 'Matter closed by',
		reabrir: 'OPEN',
		verificacao: 'MARK THE MANEUVER\'S EXECUTION IN THE PLACE CORRESPONDING',
		reabertura: 'Reopening',
		obrigacao: 'Required',
		camposObrigatorios: 'You must enter the required fields.',
		simulador: 'SIMULATOR',
		pratica: 'PRACTICE',
		teorico: 'THEORETICAL',
		matricula: 'REGISTRATION',
		detalhes: 'Details',
		daProgramação: 'Of Schedule',
		fatura: 'INVOICE',
		periodo: 'Period',
		pagamento: 'PAYMENT',
		aeroporto: 'Airport',
		distanciaEmNM: 'Distance in NM',
		distanciaCalculada: 'Calculated Distance',
		destinoAproximado: 'Approximate Destination',
		velocidadeAtual: 'Current Speed',
		reguaDigital: 'Digital Ruler',
		alertaCalculoAutomatico1: 'Automatic flight time calculation is not available,',
		alertaCalculoAutomatico2: 'average speed, fuel consumption and tank have not been added for this aircraft.',
		pagamentoNaoEfetuado: 'No Payment Done',
		adicionarPagamento: 'ADD PAYMENT',
		detalhesDoPagamento: 'DETAIL OF PAYMENT',
		detalhesDaProgramacao: 'Schedule Detail',
		PagamentoDetalhes: 'Payment',
		digiteParaBuscar: 'Type to search',
		utcDate: 'UTC Date',
		validandoTrecho: 'Validating stretch',
		valorDoPagamento: 'Payment value',
		desconto: 'Discount',
		pagamentoFeitoSucesso: 'Payment successfully added',
		tipoDePagamento: 'Payment type',
		valorTempoVoo: 'Flight time value',
		valorTotal: 'Total Value',
		valorDaHora: 'Hour Value',
		valorDoCiclo: 'Cycle Value',
		cargaHoraria: 'Workload',
		totalDoCurso: 'Course total',
		NenhumaNFSEncontrada: 'No Invoice Found',
		listaNFS: 'Invoice List',
		valorFrete: 'Cost of Freight',
		adicionar: 'ADD',
		solicitarNumeroVoo: 'Request flight number',
		informacoesIniciais: 'Initial Information',
		orgaoUtilizam: 'Organs using the aircraft',
		parametrosMidia: 'Parameters and averages',
		solicitaNumeroVoo: 'Request Flight number',
		adicionarItem: 'ADD item',
		adicionarLayer: 'Add layer',
		layer: 'Layer',
		adicionarGrupo: 'ADD Group',
		arquivo: 'File',
		descricaoLayer: 'Description for the layer',
		descricaoCompleta: 'Full description',
		PermissoesAcessoLayers: 'Access permissions to the layer',
		gestaoLayer: 'Layers Managemen',
		novoLayer: 'New Layer',
		layerCadastradoSucesso: 'Layer successfully registered!',
		layerAtualizadoSucesso: 'Layer updated successfully!',
		layerExcluidoSucesso: 'Layer successfully deleted!',
		desejaExcluirEssaPermissao: 'Do you really want to delete this permission?',
		permissaoExcluida: 'Permission deleted',
		desejaExcluirEsseLayer: 'Do you want to delete this layer?',
		salvarNovoPadrao: 'Save new pattern',
		importarLayer: 'Import Layer',
		importar: 'Import',
		inclusao: 'Inclusion',
		incluir: 'Include',
		padrao: 'Standard',
		geral: 'General',
		cadastroLayer: 'Layer Registration',
		multicamadasMapa: 'Multilayer on map',
		numeroDaFatura: 'Bill number',
		salvarPagamento: 'SAVE',
		maiorValor: 'Greater than the value.',
		notificacao: 'NOTIFICATIONS',
		nenhumaNotificacao: 'You have no notification',
		limpaTudas: 'Clear All',
		limite: 'Limit',
		historico: 'Historic',
		historicoVoo: 'Change Log',
		hNotificacao: 'Notifications',
		limpar: 'Clean',
		escolhaData: 'Choose a date',
		cCarregar: 'LOAD',
		voceTem: 'You have',
		nenhumaNotificacaoEncontrada: 'No notifications found',
		notificacaoEncontrada: 'notification (s) found',
		ver: 'See',
		naoSelecionouData: 'You did not select a date.',
		classificacaoESub: 'Classification and Subclassification',
		cadastroMotor: 'Powerplant Registration',
		motor: 'Engine',
		motores: 'Engines',
		cadastroRotaer: 'Rotaer Registration',
		contextoOperativo: 'Operating Context',
		orgaosApoiados: 'Supported Organs',
		classificacao: 'Classification',
		subclassificacao: 'Subclassification',
		acao: 'Action',
		novoMotor: 'New Powerplant',
		horimetro: 'Hourmeter',
		motorAdicionado: 'Powerplant Added',
		motorAtualizado: 'Powerplant Updated',
		dadosMotor: 'Powerplant data',
		orgaoOperador: 'Organ Operator',
		desejaAssinarEsseTrecho: 'Do you want to Sign this excerpt',
		seraNecessarioAssinatura: 'A new pilot signature will be required',
		estouCienteQuanto: 'I AM AWARE ABOUT THE INFORMATION THAT THE',
		incisoss: 'INCISES XIII A XVII',
		doArtigo: 'ART. 4 OF RESOLUTION 457',
		orgaoProprietario: 'Owner\'s Body',
		computadorDeBordo: 'Board computer',
		calculoSistema: 'System Calculation',
		sistema: 'System',
		modeloAtualizado: 'Model Updated',
		modeloInserido: 'Model Added',
		fabricanteAtualizado: 'Fabricator Updated',
		fabricanteInserido: 'Fabricator Added',
		desejaExcluirContexto: 'Do you want to Exclude this Operating Context?',
		contextoExcluido: 'Operational Context deleted.',
		contextoAtualizado: 'Updated operational context',
		contextoSalvo: 'Operational Context Saved',
		voceJaCadastrouItem: 'You have already registered this item.',
		orgaoApoiadoAtualizado: 'Organized supported updated',
		orgaoApioadoSalvo: 'Organized supported Added',
		desejaExcluirClassificacao: 'Do you want to delete this Classification?',
		classificacaoExcluida: 'Classification excluded',
		classificacaoSalva: 'Classification Added',
		classificacaoAtualizada: 'Classification updated',
		subcategoria: 'Subcategory',

		escolhaUmaClassificacaoPara: 'Choose a Classification<br/> to display the list.',
		desejaExcluirSubclassificacao: 'Do you want to delete this subclass?',
		desejaExcluirPontoInteresse: 'Do you want to delete the point of interest',
		subclassificacaoExcluida: 'Subclassification excluded',
		subclassificacaoSalva: 'Subclassification Added',
		subclassificacaoAtualizada: 'Subclassification Updated',
		designativo: 'Designative',
		salvo: 'Added',
		atualizado: 'Updated',
		qualDirigenteDesseOrgao: 'Who is the leader of this body?',
		operacional: 'Operational',
		bateria: 'Battery',
		solicitante: 'Requester',
		selecioneAeronave: 'Select an Aircraft',
		tipoDeUsuario: 'User Type',
		quantidadeDeAeronavePorColuna: 'Aircraft quantity by columns',
		casoNenhumaAeronave: 'If no aircraft is selected',
		seraExibidoTodas: 'all aircraft will be displayed in quadrant monitoring',
		seraExibidoTodasElas: 'all aircraft will be displayed',
		alterarAssinatura: 'Change Signature',
		nomeTratamento: 'Name of treatment',
		enderecoResidencial: 'Home address',
		enderecoFuncional: 'Functional address',
		assinaturaDigital: 'Digital signature',
		perfilDoUsuario: 'View Profile',
		usuarioQuePodeVer: 'User that can see this contract',
		alterarSenhaProximoLogin: 'Change password at next login?',
		emergencia: 'Emergency',
		positivo: 'Positive',
		negativo: 'Negative',
		negar: 'Deny',
		negada: 'Denied',
		alergia: 'Allergy',
		contatoDeEmergencia: 'Emergency contact',
		grauDeRelacionamento: 'Degree of Relationship',
		telefoneResidencial: 'Home Phone',
		telefoneCelular: 'Cell phone',
		jaExiste: 'Already exists.',
		emailInvalido: 'Invalid email.',
		emailJaCadastrado: 'E-mail already registered.',
		cpfJaCadastrado: 'ID already registered.',
		voceJaAddEssePerfil: 'You have already added this profile',
		voceTemAddUmPerfil: 'You have to add at least one profile.',
		assinaturaAvalicao: 'The signature must have 8 numeric digits.',
		numeroSolicitacao: 'Request number',
		recebidoPor: 'Received by',
		verTodos: 'See All',
		desejaCancelarSolicitacao: 'Do you want to cancel this request?',
		solicitacaoCancelada: 'Request canceled.',
		nSolicitacao: 'Request number',
		codigoSituacao: 'Code - Situation',
		caracteresRestantes: 'characters remaining.',
		novoTrecho: 'New leg',
		quantos: 'How many?',
		trechosQueOPassEstara: 'Leg that the passenger will be',
		cargaTransportada: 'Cargo Transport',
		haCargaASerTransportada: 'Is there cargo to be transported?',
		solicitanteDaMissao: 'Mission Applicant',
		voceEAAutoridadeSolicitante: 'Are you the requesting authority?',
		trecho: 'Leg',
		percursoASerEfetuado: 'Course to be carried out',
		partida: 'departure',
		cidade: 'City',
		estado: 'State',
		destino: 'destination',
		dataDaConclusao: 'Completion date',
		termosDeUso: 'terms of use',
		concordoComOsTermosDeUso: 'I AGREE TO THE TERMS OF USE',
		novoUsuario: 'New user',
		novaAssinatura: 'New Signature',
		assinaturaDigital: 'Digital Signature',
		porQuestoesDeSeguranca: 'for security reasons it is necessary that you change your Digital Signature',
		insiraCaso: 'or enter one if you do not have',
		digiteANovaAssinatura: 'Enter the new signature in the field below',
		assinaturaTemQueTer8: 'Signature must have 8 numeric digits',
		local: 'Local',
		pedirPecas: 'Order Parts',
		periodoDeTesteAcabou: 'The test period is over',
		entreEmContatoConosco: 'Contact us',
		solicitarSuprimento: 'Request Supplies',
		solicitarOS: 'You have to save the WO to order supplies.',
		solicitarItens: 'Request Itens',
		concluirOrdemDeServico: 'Complete work order',
		qtdSolicitado: 'Requested Quantity',
		dataDaSolicitacao: 'Requested Date',
		cartasParaAtualizar: 'Cards to update',
		salvarProcessar: 'Save and Process',
		qtdPago: 'Paid Quantity',
		parcialmentePago: 'Partly Paid',
		snDeSaida: 'Outgoing SN',
		snDeEntrada: 'Incoming SN',
		desejaexcluirEmpenho: 'Do you want to exclude this commitment:',
		naoTenhoUmAerodromoDefinido: 'I do not have a definite aerodrome.',
		haPassageiros: 'Are there Passengers?',
		descricaoDoLocal: 'Location Description',
		passageirosDaAeronave: 'Aircraft Passengers',
		pesoAprox: 'Approximate weight (Kg)',
		numeroDoPedido: 'Request Number',
		codigoDoProduto: 'Product Code',
		tipoDoProduto: 'Product Type',
		descricaoDaCarga: 'Cargo Description',
		descricaoProduto: 'Product Description',
		dadosDeEntrega: 'Delivery Data',
		dadosDeEmissao: 'Emission Data',
		detalhesDoProduto: 'Product Details',
		dadosDeDestino: 'Target Data',
		dadosGerais: 'General Data',
		calculosDoImpostos: 'Tax Calculation',
		cargaLiquida: 'Net Cargo?',
		preenchaOsDadosDoSolicitante: 'Fill in the details of the requesting authority.',
		enviarSolicitacao: 'Send request',
		atualizarSolicitacao: 'Update Request',
		resumoDaSolicitacao: 'Request Summary',
		leiaSuaSolicitacao: 'Read your request and at the end click on "SUBMIT REQUEST".',
		solicitacaoSalva: 'Request Saved',
		solicitacaoSalvaComSucesso: 'Request Saved Successfully',
		motivoApareceraDiario: 'This reason will appear in the signature of this logbook',
		numeroSolicitacao: 'Number of request',
		motivoDaEdicao: 'Reason for editing',
		solicitacoesEdicao: 'Edit Requests',
		editadoMecanico: 'Edited Mechanic',
		operacoes: 'Operations',
		aprovacao: 'Approval',
		foiGeradoUmCodigo: 'An order of mission with code was generated',
		irParaOrdemDeMissao: 'Go to the Work Order',
		definirOperador: 'Define Operator',
		quemEOOperador: 'Who is the operator of this request?',
		aSolicitacaoFoiDefinida: 'Request has been set for the operator',
		as: 'at',
		peloUsuario: 'by the user',
		essaSolicitaoTemOaval: 'Does the Operation approve this request?',
		qualOMotivo: 'What is the reason?',
		aSolicitaoTemOaval: 'The request <strong>IS</strong> supported by operations.',
		aSolicitacaoNaoAval: 'The request <strong> IS NOT </strong> supported by operations.',
		motivo: 'Reason',
		qualAeronaveVaiSerUtilizada: 'Which aircraft will be used?',
		essaSolicitaoTemAvalManutencao: 'Does the maintenance approve this request?',
		qualquerAeronave: 'Any aircraft',
		aSolicitacaoTemAvalManutencao: 'The request <strong>IS</strong> supported by maintenance.',
		aSolicitacaoNaoTemAvalManutencao: 'The request <strong>IS NOT </strong> supported by maintenance.',
		aprovarEssaSolicitacao: 'Approve this request (Generate Order of Mission)?',
		aSolicitacaoEstaAprovada: 'The request is <strong>APPROVED.</strong>',
		aSolicitacaoNaoTemAprovacao: 'The request  <strong>IS NOT</strong> approved.',
		nOrdem: 'Order Number',
		escolhaOMotivoCancelamentoOrdem: 'Choose the reason for canceling the request',
		indisponibilidadeEfetivo: 'Indispensability of effect',
		indisponibilidadeAeronave: 'Aircraft unavailability',
		solicitanteCancelou: 'Applicant canceled',
		outros: 'Others',
		cancelarOrdem: 'Cancel order',
		cancelando: 'Canceling',
		ordemCancelada: 'Canceled order',
		inicioDaOrdem: 'Order Beginning',
		descricaoDaOrdem: 'Order Description',
		descricaoOrdemDeMissao:'Mission Order Description',
		descricaoOrdemMissaoSalvoComSucesso: 'Mission Order Description successfully saved.',
		descricaoOrdemMissaoExcluidoComSucesso: 'Mission Order Description deleted correctly.',
		orgaoApoiado: 'Agency Supported',
		orgaoApoiadoUnidades: 'Agency Supported - Units',
		orgaoApoiadoAtualizadoComSucesso: 'Agency Supported successfully updated.',
		unidade: 'Unity',
		unidades: 'Units',
		ubidadeDeOrgaoApoiadoSalvoComSucesso: 'Unit of supported organ successfully saved',
		unidadeDoOrgaoApoiadoExcluidoComSucesso: 'Unit of supported organ successfully deleted',
		adicionarUnidade: 'Add Unit',
		adicionarUsuarios: 'Add User',
		adicionarOrgao: 'Add Agencies',
		haContextoOperativo: 'Is there an operational context?',
		haResalvasNaSituacao: 'Are there any caveats in the situation?',
		aeronavesEmpregadas: 'Aircraft Employee',
		aeronavesEDisponibilidade: 'Aircraft Availability',
		removerAeronave: 'Remove Aircraft',
		funcao: 'Function',
		funcaoABordo: 'Onboard Function',
		adicionarTripulacao: 'Add Crew',
		passageiros: 'Passengers',
		adicionarPassageiro: 'Add Passenger',
		copiar: 'Copy',
		roteiro: 'Itinerary',
		atualizarRoteiro: 'Update Itinerary',
		nascer: 'Sunrise',
		por: 'Sunset',
		porAero: 'By',
		distancia: 'Distance',
		autonomia: 'Autonomy',
		tempoEstimado: 'Estimated time',
		totais: 'Totals',
		distanciaTotal: 'Total Distance',
		consumoTotal: 'Total Consumption',
		tempoTotal: 'Total Time',
		atualizarMapa: 'Update Map',
		botoesEGatilhos: 'Triggers and buttons',
		esseCampoObrigatorio: 'This field is required',
		configuracoesSalvas: 'Saved settings',
		configuracoes: 'Settings',
		enviaMensagem: 'Send Message',
		adicionarPeloMenosUmaPessoa: 'You have to add at least one person.',
		quandoBotaoAlerta: 'When the alert button (RED) is canceled',
		corrijaCamposVermelho: 'Correct the fields in red',
		textoNotificacao: 'Notification Text',
		tempoNotificao: 'Notification Time',
		fecharDadosDaAeronave: 'Close aircraft data',
		existemCampoDaAeroASerem: 'There are fields to fill in the aircraft used.',
		adicionarAeronave: 'Add Aircraft',
		execucao: 'Execution',
		haNecessidadeDeAbastecimento: 'Is there a need for refueling?',
		diarias: 'Daily',
		haNecessidadeDeDiarias: 'Is there a need for daily commitment?',
		reabastecimento: 'Replenishment',
		comunicacoes: 'Communication',
		novaComunicacao: 'New Communication',
		responsavelPelaCriacaoDaOrdem: 'Responsible for the preparation of the Order of Mission',
		em: 'in',
		Em: 'In',
		em2: 'at',
		nos: 'knots',
		tempoEstimadoViaAr: 'ETA via AIR',
		aeronaveParada: 'Aircraft stopped',
		regua: 'ruler',
		milhasNauticas: 'Nautical Miles',
		milhas: 'Miles',
		quilometros: 'Kilometers',
		aOrdemInciaEm: 'The order will start in',
		reabrirOrdem: 'Reopen Order',
		fecharOrdemDeMissao: 'Close the mission order',
		atualizarOrdemDeMissao: 'Update Mission Order',
		resumoDaOrdemDeMissao: 'Update Mission Order',
		leiaAOrdem: 'Read your order and at the end click on "UPDATE ORDER".',
		ordemDeMissaoSalva: 'Order of Mission Saves',
		numeroDaOrdem: 'Order\'s number',

		diarioDeBordo: 'Logbook',
		pilotoECopiloto: 'Pilot and Co-pilot',
		carregarVoos: 'Load Flights',
		voceTemQueEsperarPois: 'You have to wait, then',
		estaPreenchendoUmDiarioDeBordo: 'is keeping a diary for this aircraft.',
		verificando: 'Checking',
		inicial: 'Initial',
		horaInicial: 'Initial Hour.',
		horaFinal: 'Final Hour.',
		final: 'Final',
		assinar: 'Sign',
		preencher: 'Write',
		adicionarTrecho: 'Add Leg',
		agruparTrecho: 'Group Leg',
		origem: 'Source',
		planejada: 'Planned',
		critica: 'Criticism',
		emergencial: 'Emergency',
		copiar: 'Copy',
		escolhaUmTrechoParaCopiar: 'Choose a leg for you to copy.',
		trechosAgrupados: 'Grouped leg',
		abaixoEstaoOsTrechosAgrupados: 'Below are the leg grouped together.',
		clickParaVerOsTrechosAgrupados: 'Click to see flights grouped',
		desagruparTrechos: 'Ungroup Leg',
		voceNaoPodeAgrupar: 'You can not ungroup these Legs, they have already been filled.',
		agruparTrechos: 'Group Legs',
		selecioneOsTrechosAgrupados: 'Select the Legs to be grouped below.',
		etiqueta: 'Label',
		salvarTrechos: 'Save Legs',
		juntadoTrechos: 'Joining Sections',
		trechoJuntado: 'Grouped Leg.',
		osTrechosPrecisamSerSeqquencial: 'The selected passages need to be sequential.',
		desagrupando: 'Ungrouping',
		trechoDesagrupado: 'Ungrouped Leg.',
		nota: 'Note',
		verificandoSePodePreencher: 'Checking if you can write out',
		desejaExcluirEsseTrecho: 'Do you want to delete this Leg?',
		verificacaoSePodeExcluir: 'Checking whether you can exclude',
		estadoDoItem: 'Item status',
		oficina: 'workshop',
		controlado: 'Controlled',
		naoControlado: 'Not Controlled',
		ondeNoEstoque: 'Where in stock',
		ordemMissaoEncerrada: 'Mission Order closed',
		requisitos: 'requirements',
		trechoExcluido: 'Excluded segment.',
		dataDoRecebimentoFisico: 'Date Physical Receipt',
		dadosdeEntregaDaNFe: 'Invoice Delivery Data',
		numeroCodigo: 'Code Number',
		desejaConfirmarVerificacaoNota: 'Do you want to verification this invoice?',
		desejaConfirmarExclusaoNota: 'Do you want to delete this invoice?',
		informacoesAdicionais: 'Additional Information',
		informacoesAdicionaisProduto: 'Addition Product Information',
		dataDoPagamento: 'Pay Day',
		dataDoMB1A2: 'Date MB1A2',
		situacaoDoPagamento: 'Payment Situation',
		senha: 'Password',
		valorUnitario: 'Unitary Value',
		numeroDaNota: 'Invoice Number',
		linhaDoContrato: 'Contract Line',

		numeroDaCE: 'CE Number',
		voceNaoPodeExcluirEditando: 'You can not delete, someone is writing the diary.',
		oTrechoEstaAberto: 'Section dated <strong>{{INICIO}}</strong>, is open and needs to be completed.',
		aberto: 'Open',
		trechoAdicionado: 'Leg added.',
		vooPreenchidoPor: 'Flight completed by',
		vooAssinadoPor: 'Signed flight by',
		vooNaoPreenchido: 'Unfilled flight',
		clickParaVerOsTrechosPor: 'Click to see flights grouped by',
		inseridoManualmentePor: 'Manually inserted by',
		manual: 'Manual',
		moduloManutencao: 'Maintenance Module',
		manuais: 'Manuals',
		esseTrechoNaoPodeSerPreenchido: 'This leg can not be completed now',
		horimetroManutencao: 'Maintenance Hourmeter',
		nenhumVooEncontrado: 'No flights found.',
		nenhumRegistroEncontrado: 'No record was found',
		ultimaInspecao: 'Last intervention',
		dataUltimaInspecao: 'Last inspection date',
		horimetroUltimaInspecao: 'Last inspection hour meter',
		essaDocumentacaoTemValidade: 'This documentation has expiration',
		validadeEmMeses: 'Validity in Months',
		horimetroProximaInspecao: 'Next inspection hour meter',
		proximaInspecao: 'Next Inspection',
		proximaInspecaoCamp: 'Next Due',
		horasDeCelulaParaAProxima: 'Airframe hours planned for the next inspection',
		horasDisponivel: 'Remaining',
		horasDisponiveis: 'Hours Available',
		proximaData: 'Next Date',
		proximaHora: 'Next Hour',
		responsavelPelaAprovacao: 'Responsible for approval for return to service',
		escolhaAOrigem: 'Choose the source',
		desejaEncerrarEssaOrdemDeMissao: 'Do you want to terminate this mission order?',
		essaOrdem: 'This Order',
		possui: 'HAS',
		naoPossui: 'DOES NOT',
		tripulacaoZero: 'You have to add a crew',
		aeronaveDuplicada: 'This aircraft is duplicated.',
		selecionarOpcaoAcima: 'You have to select an option above.',
		motorEHorario: 'Engine and Schedule',
		acionamento: 'Activation',
		novoAcionamento: 'New Activation',
		tipoAcionamento: 'Activation Type',
		corte: 'Cut',
		corteVoo: 'Deactivation',
		camp: 'Camp',
		vooDecimoCelula: 'Flight Tenth Airframe',
		vooDecimoMotor: 'Flight Tenth Powerplant',
		mediaHorasDiario: 'Average hours flown daily',
		usaCAMP: 'Uses CAMP or Followair Maintenance',
		mediaHorasMes: 'Average hours flown monthly',
		ciclosTorque: 'Torque Cycles',
		diurno: 'Daytime',
		noturno: 'Nightly',
		navegacao: 'Navigation',
		instrucao: 'Instruction',
		dadosDoVoo: 'Flight data',
		combustivel: 'Fuel',
		relacao: 'Ratio',
		partidas: 'Departures',
		pousos: 'Landings',
		guincho: 'Winch',
		gancho: 'Hook',
		ganchos: 'Hooks',
		usoDe: 'Use of',
		numeroDeVoo: 'Flight number',
		escolhaAFuncaoTripulante: 'Choose the function of this crew member',
		apresentacao: 'Presentation',
		vitima: 'Victim',
		idadeAparente: 'Apparent Age',
		passageiro: 'Passenger',
		houveCargaTransportada: 'Was there charge carried?',
		discrepanciasVerificadas: 'Discrepancies Checked',
		adicionarDiscrepancia: 'Add Discrepancy',
		dadosDaMissao: 'Mission Facts',
		base: 'Base',
		naturezaDoVoo: 'Nature of Flight',
		chamada: 'Call',
		atividade: 'Activity',
		coracao: 'Heart',
		rim: 'Kidney',
		cor: 'Color',
		figado: 'Liver',
		cornea: 'Cornea',
		esclero: 'Scleroderma',
		pancreas: 'Pancreas',
		baco: 'Spleen',
		unidadeDeConservacao: 'Conservation Unit',
		baseDeOrigem: 'Base of Origin',
		brigadistas: 'Brigadists',
		socorridos: 'Rescued',
		finalizarTracho: 'Finish Leg',
		editarTrecho: 'Edit Leg',
		editaveis: 'Editable',
		atualizarTrecho: 'Update Leg',
		assinarESalvarTrecho: 'Subscribe and Save Leg',
		selecioneOTipo: 'Select type',
		com: 'With',
		sem: 'Without',
		selecioneUmaOrdemDeMissao: 'Select a Mission Order',
		nenhumaOrdemFoiEncontrada: 'No requests found.',
		selecioneUmaAeronave: 'Select an aircraft',
		selecioneUmaPrevencaoQualificada: 'Select qualified prevention',
		selecioneAPrevencaoQualificadaAbaixo: 'Select a qualified prevention below',
		naoEncontramosSuaAero:
			'We did not find this aircraft within the mission order, if you wanted to import the aircraft data from the mission order, simply click on the model below.',
		selecioneOsPassageirosTrecho: 'Select the passengers that flew this leg',
		tempoDePreenchimento: 'Filling Time',
		desejaContinuarAPrrencher: 'Do you wish to continue filling in this logbook?',
		continuar: 'Continue',
		desejaFinalizarTrecho: 'Do you want to end this leg?',
		desejaAtualizarTrecho: 'Do you want to update this leg?',
		revisar: 'Review',
		finalizar: 'Finish',
		assinarEFinalizar: 'Sign and Finish',
		carregandoDiario: 'Loading logbook',
		copiandoDiario: 'Copying logbook',
		umDessesCampoEObrigatorio: 'One of these fields is required.',
		voceTemQueEscolherUnidade: 'You have to add at least one unit.',
		carregandoHorimetro: 'Loading horimetre',
		atualizandoTempo: 'Updating time',
		mecanico: 'Mechanic',
		discrepancias: 'Discrepancies',
		oTrechodeInicioTexto:
			'The start section <strong>{{TRECHO}}</strong>, on <strong>{{INICIO}}</strong>, is open and needs to be completed.',
		assinando: 'Signing',
		trechoAssinado: 'Leg Signed',
		nenhumaAcao: 'No action',
		acaoTomada: 'Action taken',
		concluido: 'Completed',
		trigrama: 'Trigram',
		avaliar: 'Measure',
		avaliarDiscrepancia: 'Discrepancy measure',
		nenhumaDiscrepanciaEncontrada: 'No discrepancies found',
		nenhumaAcaoFoiTomadaDiscrepancia: 'No action was taken for this discrepancy.',
		essesDados: 'These data',
		refereSeAoInicio: 'refers the beginning',
		doContrato: 'of the contract',
		numeroDoContrato: 'Contract Number',
		adicionarAcao: 'Add Action',
		concluirDiscrepancia: 'Conclude Discrepancy',
		discrepanciaConcluida: 'Discrepancy Completed',
		acaoCorretiva: 'Corrective action',
		acaoPreventiva: 'Preventive action',
		monitoramento: 'Monitoring',
		monitoramento1: 'Monitoring',
		monitorada: 'Tracked',
		um: 'One',
		dois: 'Two',
		tres: 'Three',
		quatro: 'Four',
		numMotores: 'Engine\'s Number',

		alertas: 'Alerts',
		indisponibilizarAeronave: 'Unavailable Aircraft',
		responsavel: 'Responsible',
		acao: 'Action',
		destinatarios: 'Addressee',
		consumivel: 'Consumable?',
		novaAcao: 'New Action',
		novaDiscrepancia: 'New Discrepancy',
		desejaConcluirEssaDiscrepancia: 'Do you want to complete this discrepancy?',
		escolhaUmaAcao: 'Choose an action above.',
		destinatario: 'Addressee',
		gerarOrdemDeServico: 'Generate Service Order?',
		acaoSalva: 'Action Saves',
		discrepanciaSalva: 'Discrepancy Saves',
		assinaturaEletronica: 'Electronic signature',
		digiteSuaAssinatura: 'Enter your signature',
		assinaturaInvalida: 'Invalid signature.',
		usoDeAereonave: 'Use of aircraft',
		cartaDeSituacao: 'Letter of Situation',
		cartaDeSituacaoCalendario: 'Situation Letter',
		prevencao: 'Deterrent',
		prevencaoDespacho: 'Prevention',
		aListaAbaixo: 'The list below',
		estaExibindo: 'is showing',
		dosUltimos: 'the last',
		dias: 'days',
		qualificada: 'Patrol',
		delito: 'Crime',
		modeloDoMapa: 'Map template',
		calor: 'Heat',
		marcadores: 'Markers',
		gerarMapa: 'Generate Map',
		resultados: 'Results',
		tentativas: 'Attempts',
		consumados: 'Finished',
		com: 'With',
		sem: 'Without',
		totalDeOcorrencias: 'Total occurrences',
		diasMaisComuns: 'Common days',
		horarioMaisComum: 'Most common time',
		timeline: 'TIMELINE',
		calendario: 'Calendar',
		lote: 'Batch',
		tipoControle: 'Control Type',
		horario: 'Schedules',
		textoDiaDiscrepancia: 'has a greater number of cases occurring on',
		textoHorarioDiscrepancia: 'at a time close to',
		localizacao: 'Location',
		latitude: 'Latitude',
		latitudeFinal: 'Final latitude',
		latitudeInicial: 'starting latitude',
		longitude: 'Longitude',
		logitudeInicial: 'Initial Logitude',
		logitudeFinal: 'Final Logitude',
		encaminharParaExecucao: 'Forward the order to execute',
		inicioOrdem: 'Order Beginning',

		cadastrarNovoDespacho: 'Register new dispatch',
		novoDespacho: 'New Dispatch',
		numeroDoDespacho: 'Dispatch',
		numeroDoEmpenho: 'Effort number',
		encerrada: 'Closed',
		movimentacao: 'Handling',
		movimentacaoDeCombustivel: 'Fuel Handling',
		dadosDoDespacho: 'Dispatch Information',

		primeiroPilotoComando: '1st Pilot in Command',
		segundoPilotoComando: '2st Pilot in Command',

		finalidade: 'finality',
		suprimentoAeronauticos: 'Aeronautical Supplies',
		suprimentos: 'Supplies',
		validarDados: 'VALIDATE AIRCRAFT AND ENGINE DATA',
		confirmeDadosAeronave: 'Confirm that the aircraft and engine data are correct',
		item: 'Item',
		finalizarOrdemDeServico: 'Finish Work Order',
		discrepancias: 'Discrepancies',
		ordemServico: 'Work Order',
		sistemaIntegrado: 'Integrated System',
		controleDeInspecao: 'Inpections Control and Manual',
		avioesEDisponibilidade: 'Aircraft and Availability',
		solicitacoes: 'Requests',
		solicitacoesParaVoce: 'Requests for you',
		solicitacoesFeitaPorVoce: 'Requests made by you',
		solicitacoesDeEdicao: 'Editing Request',
		procedimento: 'Procedure',
		padraoProcedimento: 'Standard Operating',
		cliqueParaAnexar: 'CLICK HERE TO ATTACH',
		cliqueAqui: 'Click Here',
		novo: 'NEW',
		atualizacaoTempoManual: 'Manual time update',
		casoNaoUtilizeDiario:
			'If you do not use the logbook to update the manuals, you can enable this option, with this will display a tab \'UPDATES\' on the GENERAL VIEW screen, allowing you to update maintenance manually.',
		habilitarCargasEmTempos: 'Enable tempo loading',
		adicionarCargaOpcao:
			'This option allows you to display an \'ADD LOAD\' button on each work card in maintenance.',
		utilizaManutencao: 'Uses Maintenance',
		dataInicioCarga: 'Start date of first charge',
		inicioCargaOpcao:
			'When you enable maintenance in the followair, it is necessary to give the first load in the inspections and tasks already done, doing this, it is necessary to put the start date of this load, from this day, if you have log books filled and / or update loads, the system will update the times of the aircraft and components that are connected to it.',
		dataProximaInspecao: 'Next inspection date',
		inspecaoEmMeses: 'Next inspection in Months',
		adicionarConfiguracao: 'Add Settings',
		pilotos: 'Pilot',
		comissarios: 'commissioner',
		adicionado: 'added',
		arrasteParaMover: 'Drag to move table items',
		nenhum: 'No',
		emAndamento: 'IN PROGRESS',
		abertoPor: 'opened by: ',
		dataPrevisao: 'Forecast Date: ',
		dataLimite: 'Deadline',
		dataEncerramento: 'Closing Date: ',
		oQueEstaAcontecendo: 'What is happening? ',
		novaInteracao: 'New Interaction ',
		baixa: 'Low',
		media: 'Medium',
		alta: 'High',
		selecionePrioridade: 'Select a priority',
		selecioneUmContrato: 'Select a Contract',
		prioridade: 'Priority',
		tituloTicket: 'Title ',
		encontrados: 'Found ',
		nomePrincipal: 'First Name ',
		intercambiaveisAdicionadas: 'Interchangeable added',
		tituloTicketForm: 'Title: ',
		salvar: 'Save',
		numeroTicket: 'Ticket Number: ',
		salvoComSucesso: 'Saved successfully',
		chamadoConcluido: 'Call Completed',
		novoTicket: 'New Ticket',
		filtrarPorNome: 'Filter by name: ',
		porArtigo: 'By',
		filtrarPosicoes: 'Filter positions',
		encerramento: 'Closing',
		pilotoComandante: 'Commanding pilot',
		conferencia: 'Conference',
		cadastroConfigAeronave: 'Aircraft Settings Register',
		cadastroLicenca: 'License Registration',
		usuarioLicenca: 'License User',
		unidadeArmazenamento: 'Unit Storage',
		cfg: 'Configuration',
		dataHorimetroAtual: 'Current Time Meter',
		dataHorimetro: 'Data Hour Meter',
		endereco: 'Address',
		anual: 'Annual',
		grupoOrgaos: 'Organs Group',
		novaPrestacao: 'NEW SERVICE PROVISION',
		bastaClicar: 'Just click on the map to add a new point of interest, or click on one on the map to edit it',
		selecioneOrgaos: 'Select the Organs',
		selecionadoOrgaos: 'Selected Organs',
		pontosInteresse: 'Points of Interest',
		novoPonto: 'New Point',
		ponto: 'Point',
		excluirPontoInteresse: 'Delete point of interest',
		relatorioCIV: 'CIV Report',
		empenho: 'Effort',
		empenhos: 'Efforts',
		faturas: 'invoices',
		pesquisar: 'search',
		pesquisarPor: 'Search for: ',
		alternativos: 'Alternatives',
		aplicavel: 'applicable',
		numeroDoContrato: 'Contract\'s number',
		dataCotacao: 'Quotation date',
		paraAdicionarEmpenhos: 'To add Efforts',
		eNecessario: 'needs to generate an invoice',
		atravesDaBusca: 'through the search bar',
		caso: 'Case',
		usuarioNaoTenha: 'user do not have',
		privilegiosParaVer: 'privilege to see',
		todosOsContratos: 'all contracts',
		gerarFatura: 'Invoice Generate',
		upload: 'upload',
		celula: 'Airframe',
		piltoEmComando: 'Pillot in command',
		pilotoEmInstrucao: 'Pillot in Instruction',
		calendarioSemanal: 'Weekly Calendar',
		adicionarVoo: 'Add Flight',
		selecionarSemana: 'Select Week',
		naoPossivelExcluirUnidadeMedidaSuprimentosLigados: 'You cannot delete a unit of measure with supplies attached to it',
		estoqueUnidadeMedida: 'Inventory - Units of Measure',
		desejaExcluirUnidadeMedida: 'Do you want to delete this Unit of Measure?',
		duplicar: 'Duplicate',
		confirmarDuplicar: 'Confirms you want to duplicate',
		solicitacoesItensAvulsas: 'Single Item Requests',
		dataEmissao: 'Date of issue',
		setorDestino: 'Target sector',
		novoRelatorio: 'New Report',
		anexoSolicitacao: 'Request\'s Attachment',
		mediaManual: 'Manual Average',
		toleranciaDisponivel: 'Tolerance Available',
		oHorimetroDeveSerMenorQueOAtual: 'The hour meter must be smaller than the current',
		disponibilizarAeronave: 'Make Aircraft Available',
		indisponibilizarAeronave: 'Make Aircraft Unavailable',
		porcentagem: 'Percentage',
		aeronaveDestino: 'Aircraft Destination',
		eImportanteFazerEsseProcedimento: 'It is important to do this procedure before the aircraft starts to fly',
		equipamentoTrocado: 'Equipment Changed',
		dataInvalida: 'Invalid Date',
		altitudeTerreno: 'Ground Altitude',
		alturaVoo: 'Flight Height', 
		desejaExcluirEsse: 'Deseja excluir esse',
		alturaVoo: 'Flight Height',
		imagensCadastradas: 'Registered Images',
		cadastrarImagens: 'Register Images',
		nenhumaImagemCadastrada: 'No Image Registered',
		planoDeFundoAtual: 'Current Background',
		definirPlanoDeFundo: 'Set Background',
		definirComoPlanoDeFundo: 'Set As Background',
		excluirImagem: 'Delete Image',
		salvarImagem: 'Save Image',
		anexeUmaImagem: 'Attach an image',
		cliqueEmAlgumaImagem: 'Click on any image',
		cadastroTipoCarga: 'Load Type Registration',
		suporte: 'Support',
		chamadaDeSuporte: 'Support Call',
		manualOnline: 'Online Manual',
		osArquivosNãoPodemSerMaiorQue: 'The file(s) cannot be larger than',
		interacaoSalva: 'Interaction saved',
		sigla: 'Initials',
		detalhar: 'Detail',
		opcoes: 'Options',
		liquida: 'Liquid',
		perigosa: 'Dangerous',
		outras: 'Others',
		cargaSalvaComSucesso: 'Load saved successfully',
		houveUmErroAoTentarSalvar: 'There was an error while trying to save',
		erroConectarServidor: 'Error connecting to the server.',
		desejaExcluirACarga: 'Do you want to delete the load',
		cargaExcluidaComSucesso: 'Load successfully deleted',
		tipoOrdemDeMissao:'Mission Order Type',
		tipoOrdemMissaoSalvoComSucesso: 'Mission Order Type successfully saved.',
		tipoOrdemMissaoExcluidoComSucesso: 'Mission Order type deleted correctly.',
		valorNumericoInvalido: 'Invalid numeric value.',
		quantidadeEstimadaPassageiros: 'Estimated Number of Passengers',
		tipoCombustivel: 'Type of fuel',
		unidadeOrcamentaria: 'Budgetary Unit',
		quantidadeDeLitros: 'Quantity of Liters',
		valorDoLitro: 'Liter Value',
		adicionarValorAoContrato: 'Add value to the contract',
		adicionarAditivo: 'Add additive',
		selecioneUmEmpenho: 'Select an effort',
		numeroDoCe: 'Number of delivery receipt',
		porcentagemConsumidaDoEmpenho: 'Percentage of effort consumed',
		consumidoOValorTotalDoEmpenho: 'The total amount of effort was consumed',
		valorNaoPermitidoPorUltrapassarOValorEmpenhado: 'Amount not allowed for exceeding the effort amount',
		entradaRegistrada: 'Registered entry',
		corrijaOsCamposEmVermelho: 'Correct the fields in red',
		valorEmpenhado:'Efforted Value',
		porcentagemConsumidaDoContrato: 'Contract consumed percentage',
		consumidoOValorTotalDoContrato: 'Total contract value was consumed',
		valorNaoPermitidoPorUltrapassarOValorContratado: 'Amount not allowed for exceeding the contracted amount',
		gestaoDeContratos: 'Contract Management',
		valoresDoContrato: 'Contract values',
		aditivos: 'Additions',
		aditivo: 'Additive',
		valorDoContrato: 'Contract value',
		valoresAtivos: 'Active values',
		desejaExcluirADocumentacao: 'Do you want to delete the documentation',
		documentacaoExcluidaComSucesso: 'Documentation successfully deleted',
		desativarTodasInspecoes: 'To disable all inspections, a justification is required',
		desativarInspecoes: 'To disable this inspection, a justification is required',
		ativarTodasInspecoes: 'To activate all inspections, a justification is required',
		ativarInspecoes: 'To activate this inspection, a justification is required',
		habilitarInspecao: 'Enable Inspection',
		desabilitarInspecao: 'Disable Inspection',
		adicionarFrequencia: 'Add frequency', 
		vidaUtil: 'Lifespan',
		volumeAtual: 'Current volume',
		desejaExcluir: 'Do you want to delete',
		tipoUnidadeArmazenamento: 'Storage Unit Type',
		monitora: 'Monitor',
		veiculo: 'Vehicle', 
		quantidadeAtual: 'Current Quantity', 
		capacidadeMaxima: 'Maximum Capacity',
		icone: 'Icon', 
		cep:'Zip Code',
		logradouro: 'Address',
		complemento: 'Complement',
		contato: 'Contact', 
		cadastroTipoArmazenamento: 'Storage Type Register',
		descricaoTipoArmazenamento: 'Storage Type Description',
		inspecaoExcluidaComSucesso: 'Inspection successfully deleted',
		mecanicoResponsavel: 'Responsible Mechanic',
		inspetorResponsavel: 'Responsible Inspector',
		tarefaCadastrada: 'Registered Task',
		tarefaAdicionada: 'Task Added',
		servicosAExecutar: 'Services to be executed',
		servicosExecutados: 'Services performed',
		itemAtualizado: 'Updated item',
		entradaEfetuada: 'Checked in',
		adicionarTarefas: 'Add Tasks',
		adicionarTarefa: 'Add Task',
		carregandoMovimentacoes: 'Loading drives',
		digiteOItemQueDesejaBuscar: 'Enter the item you want to search',
		atualizandoLista: 'Updating list',
		naoFoiPossivelAssinar: 'Could not subscribe',
		naoFoiPossivelAssinarOS: 'Unable to sign Service Order',
		aTarefaFoiSalvaComSucesso: 'Task has been saved successfully',
		asTarefasForamSalvasComSucesso: 'Tasks have been successfully saved',
		aTarefaFoiAdicionadaComSucesso: 'The task was successfully added',
		asTarefasForamAdicionadasComSucesso: 'Tasks have been successfully added',
		naoHaNenhumaTarefaCadastrada: 'There is no task registered',
		naoFoiPossivelCancelar: 'Unable to cancel',
		confirmar: 'Confirm',
		unidadeOrgaoApoiado: 'Organ Supported Unit',
		cadastroDeVeiculos: 'Vehicle Registration',
		veiculoExcluidoComSucesso: 'Vehicle successfully deleted',
		placa: 'License plate',
		prefixoOuIdentificacao: 'Prefix/Identification',
		prefixoOuIdentificacaoDoVeiculo: 'Prefix / Vehicle Identification',
		especieOuTipo:'Species/Type',
		codigoRenavan: 'Renavan Code',
		chassi: 'Car Chassis',
		corPredominante: 'Predominant Color',
		marcaOuModelo: 'Brand / Model',
		anoFabricacao: 'Year of manufacture',
		anoModelo: 'Model Year',	
		capacidadeOuPotenciaOuCilindrada:'Capacity / Power / Cylinder Capacity',
		podeSerAlocado: 'Allocation Permission',
		numeroPatrimonio: 'Equity Number',
		radio: 'Radio',
		kmAtual: 'Current Km',
		validade: 'Shelf life',
		alerta: 'Alert',
		inspecaoAdicionadaComSucesso: 'Inspection added successfully'
	},

	menuMatricula: {
		exibirMatricula: 'Show License Plate',
		candidadoEstrangeiro: 'Foreign Candidate?',
		documentacaoApresentada: 'Featured Documentation (Candidates)',
		cartaoIdentidade: 'ID card',
		cpf: 'ID',
		tituloEleitor: 'Title of Elector',
		certidaoCapacidadeFisisca: 'Physical Fitness Certificate',
		certidaoEscolaridade: 'Certificate of Education',
		atestadoBonsAntecedentes: 'Certificate of Good Background',
		casoPossuaLicenca: 'If you have a license',
		documentacaoApresentadaEstrangeiros: 'Featured Documentation (Foreign Candidates)',
		requerimentoDoCantidado: 'Application for Candidate',
		copiaDocumentoViagem: 'Copy of Travel Document',
		carteriaIdentidadeEstrangeirosValidade: 'Identity card for foreigners with validity of stay',
		copiaCertificadoEscolaridadeEstrangeiro: 'Copy of certificate of schooling (officially translated) from elementary school',
		copiaLicencaAtividade: 'Copy of the specific activity license or equivalent document (translated officially)',
		permissaoResidencia: 'Residence Permit',
		declaracaoSubJudice: 'Declaration of the request that it is not SUB-JUDICE',
		termoMatricula: 'Registration Form',
		termoTexto:
			'I DECLARE THAT THIS STUDENT IS ENROLLED IN THIS COURSE, FROM <strong>{{dataMatricula}}</strong>, REGISTRATION <STRONG>{{matricula}}</strong>, THE DOCUMENTATION REQUIREMENTS HAVE BEEN DELIVERED, ACCOMPANIED BY <STRONG>{{qtd4x4}}</STRONG> PORTRAITS 3X4.',
		assinaturaAluno: 'SIGNATURE OF STUDENT',
		responsavelMatricula: 'RESPONSIBLE FOR THE REGISTRATION',
		informacoesMatricula: 'Registration Information',
		matriculaSalva: 'Registration Successfully save!',
		numeroMatricula: 'Registration Number',
		naoSalva: 'Does not save',
		cadastroAPU: 'APU Registration',
		tipos: 'Types',
		capacidade: 'Capacity',
		quantitativo: 'Quantitative',
		desejaExcluirEsseTipo: 'Do you want to delete this Type?'
	},

	registroDadosVoo: {
		variaveisDeMonitoramento: 'MONITORING VARIABLES',
		altitudeTerreno: 'Ground Altitude',
		altitudeVoo: 'Flight Altitude',
		alturaVoo: 'Flight Height',
		velocidadeAeronave: 'Aircraft Speed',
		proa: 'BOW',
		pressaoOleo: 'Oil Pressure',
		turbina: 'Turbine',
		torque: 'Torque',
		altitudeAeronave: 'Aircraft Attitude',
		aceleracaoVertical: 'Vertical Acceleration',
		visualizacaoInstrumentos: 'Instruments View',
		visualizacaoGraficos: 'Graphics View',
		variacaoTorque: 'Torque Variation',
		pressaoDoOleoTurbina: 'Turbine Oil Pressure'
	},

	perfil: {
		perfilDoUsuario: 'User profile',
		editarPerfil: 'Edit profile',
		novoPerfil: 'New Profile',
		nomePerfil: 'Name',
		perfilAtualizado: 'Updated profile',
		PerfilInserido: 'Profile inserted',
		clickEmNovo: 'click in \'New\'',
		paraAdicionar: 'to add',
	},

	conversao: {
		dia: 'day',
		mes: 'month',
		hora: 'hour',
		ano: 'year',
		ciclos: 'cycle',
		dias: 'days',
		meses: 'months',
		horas: 'hours',
		anos: 'years'
	},

	gestao: {
		gestaoDe: 'Management'
	},

	pais: {
		brasil: 'Portuguese',
		eua: 'English',
		paraguai: 'Spanish',
		frances: 'French',
		alemao: 'German',
		italiano: 'Italian',
		espanhol: 'Spanish',
		portugues: 'Portuguese',
		ingles: 'English'
	},

	uploadfile: {
		download: 'Download',
		extPermitidas: 'Allowed extensions',
		tituloForm: 'Attach file',
		erroMSG: 'This type of file is not allowed.',
		foto: 'Photo'
	},

	calendario: {
		hoje: 'Today',
		domingo: 'sunday',
		segundaFeira: 'monday',
		terçaFeira: 'tuesday',
		quartaFeira: 'wednesday',
		quintaFeira: 'thursday',
		sextaFeira: 'friday',
		sábado: 'saturday'
	},

	login: {
		entrar: 'Login',
		digiteLogin: 'Type your login',
		digiteSenha: 'Type your password',
		digiteSenhaAtual: 'Type your actual password',
		textoErro: 'User or password are invalid',
		entrando: 'Entering'
	},

	menuSolicitaApoio: {
		destino: 'Destination',
		partida: 'Departure',
		menuDataEfim: 'The start and end date are obligatory',
		solicitaApoio: 'Request',
		apoioAereo: 'Air support',
		menuNovaSolicitacao: 'New Request',
		menuSolicitaNova: 'New',
		menuSolicitacao: 'Request',
		menuCargo: 'Position',
		menuLocalOperacao: 'Local of Operation',
		menuCoordenador: 'Coordinator',
		menuCoordenadorSolo: 'Ground Coordinator',
		menuMissaoApoio: 'Support Mission',
		menuOrgaoSolicitante: 'Organ',
		menuEscolha: 'Choose',
		menuNomeOperacao: 'Operation Name',
		menuInicioOperacao: 'Operation start date',
		menuFimOperacao: 'Operation end date',
		menuGrauPrioridade: 'Level of priority',
		menuTipoOcorrencia: 'Type of occurrence',
		codigoPnapa: 'Pnapa code',
		naturezaEtipo: 'You have to add at least one Nature and Type.',
		escolhaArquivo: 'Choose one file and click load.',
		corrigirCampos: 'Please, correct the fields in red above.',
		escolherLocal: 'You have to choose at least  one local',
		novaOrdemMissao: 'New Mission Order',
		ordemMissaoInserida: 'New mission order inserted successfully',
		solicitacaoAtualizada: 'Request updated successfully.',
		solicitacaoAdicionada: 'Request added successfully.',
		statusAtualizado: 'Status updated successfully.',
		removidos: 'All removed',
		dadosAtualizados: 'Data updated successfully!'
	},

	menuVoo: {
		menuVvoo: 'T Flight',
		menuVtdesc: 'T Flight Tenth',
		menuVescolha: 'Choose the aircraft to carry the days it flew.',
		menuVaeronave: 'Aircraft',
		menuVatualizaTrechos: 'Update Legs',
		menuVatualizaTrechos2:
			'When updating the legs, the system will fetch all portions of the day and include them in the flight report, altered legs will be kept.',
		menuVfechaRelatorio: 'Close Report',
		menuVreabreRelatorio: 'Reopen Report',
		menuVestadoAlagoas: 'State of Alagoas',
		menuVssp: 'SSP',
		menuVcaesp: 'CAESP',
		menuVrelatorio: 'Flight report',
		menuVnumRelatorio: 'Report Nº',
		menuVcontato: 'Contact',
		menuVchefeCaesp: 'Cheief of CAESP: 98884-7133',
		menuVchefeOp: 'Cheief of Operations: 98824-9657',
		menuVbaseMaceio: 'Maceió Base: 4009-2040',
		menuVbaseArapiraca: 'Arapiraca Base: 3530-3518',
		menuVprefixo: 'Prefix',
		menuVmodelo: 'Model',
		menuVtrechos: 'Legs',
		menuVnum: 'Nº',
		menuVde: 'From',
		menuVpara: 'To',
		menuVcorte: 'Landing',
		menuVpartida: 'Take off',
		menuVtvoo: 'Flight Time',
		menuVtdec: 'Flight Time Tenth',
		menuVpousos: 'Landings',
		menuVcomb: 'Fuel',
		menuVpax: 'Passengers',
		menuVtotal: 'Total',
		menuVhistorico: 'History of legs',
		historico: 'History',
		menuVtipoMissao: 'Type of mission',
		menuVnaturezaVoo: 'Nature of Flight',
		menuVmissao: 'Mission',
		menuVcodigo: 'Code',
		menuVaerotatico: 'Op. Aerotático / Sup. Médico',
		menuVocorrencia: 'Occurrence',
		menuVmapa: 'Map of legs',
		menuVnumTrecho: 'legs Nº',
		menuVsemMapa: 'No map found.',
		menuVerroVoos: 'Error to load maps of month.'
	},

	menuOrdemMissao: {
		menuOrdem: 'Order',
		menuMissao: 'Mission',
		menuOrdemmissao: 'Order Mission',
		menuNova: 'New',
		menuNovaOrdem: 'New Order',
		menuOrdemSolicitacao: 'Requested',
		menuOrdemEscolha: 'Choose'
	},

	menuMonitoramento: {
		menuMonitora: 'Monitoring',
		menuTempoReal: 'Real Time',
		menuMonitoraAeronaves: 'Aircrafts',
		menuAeronaveNaoVoou: 'The aircraft did not fly today.',
		horaMes: 'Hour/Month',
		horaDia: 'Hour/Day',
		voosDia: 'Current flights',
		nenhumaManutencao: 'No scheduled maintenance.',
		totalCiclosVoadios: 'Total winged cycles'
	},

	menuRastreamento: {
		menuRastrea: 'Tracking',
		menuRastreaAeronave: 'Aircraft',
		menuRmudar: 'Change',
		menuRtotal: 'Total'
	},

	menuRGhorasVoadas: {
		menuRGaeronave: 'Aircraft',
		menuRGdataInicio: 'Start Date',
		menuRGdataFim: 'End Date',
		menuRGou: 'Or',
		menuRGrelatorio:
			'This report has operational purposes and may generate a difference for more or less in total hours flown compared to the logbook.',
		menuRGhorasReportadas: 'Reported hours'
	},

	menuRGestatisticaVoo: {
		menuAeronave: 'Aircraft'
	},

	menuRGoperacoes: {
		menuAeronave: 'Aircraft',
		menuTipo: 'Type',
		menuRelatorioOp: 'Report of Operations',
		menuRGtipo: 'Type',
		menuRGde: 'From',
		menuRGpara: 'To',
		menuRGpartida: 'Take off',
		menuRGtvoo: 'Time Flight',
		menuRGtdec: 'Tenth Flight Time',
		menuRGpousos: 'Landings',
		menuRGcomb: 'Fuel',
		menuRGpax: 'Passengers'
	},

	menuRGsolicitacoes: {
		menuRGrSolicitacoes: 'Requests Report',
		menuRGnome: 'Name',
		menuRGprioridade: 'Priority',
		menuRGorgao: 'Organ',
		menuRGsemdados: 'No data found.',
		menuRGoperacao: 'Operation',
		menuRGsolicitacao: 'Requests'
	},

	menuRGordemmissao: {
		menuOMnome: 'Name',
		menuOMprioridade: 'Priority',
		menuOMorgao: 'Organ',
		menuOMsemdados: 'No data found.',
		menuOMoperacao: 'Operation',
		menuOMmissao: 'Mission Order',
		menuOMcoordenador: 'Coordinator',
		menuOMtripulantes: 'Crewmember',
		menuOMlotacao: 'Sector',
		menuOMemail: 'E-mail',
		menuOMtelefone: 'Telephone',
		menuOMcargo: 'Position',
		menuOMinicio: 'Start',
		menuOMfim: 'End',
		menuOMnaoDisponivel: 'not available at this moment.',
		menuOMguarnicao: 'Aircrew',
		menuOMadicionados: 'Added',
		menuOMenviar: 'Send and save',
		menuOMdataInicio: 'The Order of Mission period must be between the Request period.',
		menuOMescolha: 'Choose',
		menuOMdataMaior: 'The start date cannot be bigger than end date',
		menuOMordemAtualizada: 'Order updated successfully.',
		menuOMordemAdicionada: 'Order added successfully.',
		menuOMordemEncerrada: 'Order closed successfully.'
	},

	menuAGnovoGrupo: {
		naturezaManutencao: 'Real Estate Management',
		cadGrupoTitulo: 'Group Inspection',
		menuAGcadGrupo: 'New Group',
		menuAGdescGrupo: 'Description',
		menuAGdescGrupo2: 'Group Description',
		menuAGeditGrupo: 'Edit Group',
		menuAGtextoG1: 'Click on \'New\'',
		menuAGtextoG2: 'Click on icon',
		menuAGtextoG3: ' at list alongside.',
		menuAGattGrupo: 'Group updated',
		menuAGaddGrupo: 'Group added'
	},

	menuAGstatus: {
		cadStatusTitulo: 'Status Register',
		menuAGcadStatus: 'New Status',
		menuAGcadStatus2: 'Register status',
		menuAGdescStatus: 'Description',
		menuAGeditStatus: 'Edit status',
		menuAGdescStatus2: 'Status description',
		menuAGattStatus: 'Status updated',
		menuAGaddStatus: 'Status added',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside.',
		obrigaStatus: 'Require you to enter a note when you select this status?'
	},

	menuAGnovoOrgao: {
		cadOrgaoTitulo: 'Organ Register',
		menuAGcadOrgao: 'New Organ',
		menuAGdescOrgao: 'Description',
		menuAGdescOrgao2: 'Organ Description',
		menuAGeditOrgao: 'Edit Organ',
		menuAGtextoG1: 'Click on \'New\'',
		menuAGtextoG2: 'Click on icon',
		menuAGtextoG3: ' at list alongside.',
		menuAGattOrgao: 'Organ updated',
		menuAGaddOrgao: 'Organ added'
	},

	menuAGnovoCargo: {
		menuAGcadCargo: 'New Post',
		menuAGdescCargo: 'Description',
		menuAGdescCargo2: 'Post Description',
		menuAGeditCargo: 'Edit Post',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside.',
		menuAGattCargo: 'Post updated',
		menuAGaddCargo: 'Post added',
		menuAGcadCargo2: 'Post register'
	},

	menuAGnovoPosto: {
		menuAGcadPosto: 'New Post',
		menuAGdescPosto: 'Description',
		menuAGeditPosto: 'Edit Post',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside.',
		menuAGattPosto: 'Post updated',
		menuAGaddPosto: 'Post added'
	},

	menuAGnovoUsuario: {
		msgPrivilegio: 'Do you want to add more privileges?',
		pClasse: '1st Class',
		sClasse: '2nd Class',
		tClasse: '3rd Class',
		menuAGcadUser: 'New User',
		menuAGnome: 'Name',
		menuAGcpf: 'ID',
		menuAGcelular: 'Cellphone',
		menuAGcargo: 'Position',
		menuAGcargo2: 'Position',
		menuAGcadastroUsuario: 'User Registry',
		menuAGeditarUsuario: 'Edit user',
		menuAGdadosCadastrais: 'Registration data',
		menuAGemail: 'E-mail',
		menuAGtel1: 'Telephone 1',
		menuAGtel2: 'Telephone 2',
		menuAGcel1: 'Cellphone 1',
		menuAGcel2: 'Cellphone',
		menuAGid: 'Identity',
		menuAGorgao: 'Organ',
		menuAGnumOrdem: 'Order Number',
		menuAGmatricula: 'Registration',
		menuAGnomeGuerra: 'War Name',
		menuAGposto: 'Office/Grade',
		menuAGcep: 'ZIP CODE',
		menuAGlogradouro: 'Public place',
		menuAGnum: 'Number',
		menuAGcomplemento: 'Complement',
		menuAGbairro: 'Neighborhood',
		menuAGcidade: 'City',
		menuAGestado: 'State',
		menuAGguarnicao: 'Is part of garrison?',
		menuAGsistema: 'Do you have access to the system?',
		menuAGsim: 'Yes',
		menuAGnao: 'No',
		menuAGacesso: 'System access',
		menuAGlogin: 'Login',
		menuAGsenha: 'Password',
		menuAGbranco: 'In blank, keep the same password.',
		menuAGdepto: 'Departament',
		menuAGprivilegio: 'System privileges',
		menuAGremover: 'Remove all privileges',
		menuAGmarcarTodos: 'Mark all',
		menuAGexcluir: 'Delete user',
		menuAGdesejaExcluir: 'Do you wish to delete this user?',
		menuAGanac: 'ANAC code',
		menuAGtipo: 'Type',
		menuAGguarnicao2: 'Garrison',
		menuAGtipoCertificado: 'Certified type',
		menuAGvalidadeCertificado: 'Certified validate',
		menuAGusuarioExcluido: 'User deleted successfully.',
		menuAGusuarioAtualizado: 'User updated successfully.',
		menuAGusuarioAdicionado: 'User added successfully.'
	},

	menuAGinspecao: {
		menuAGtInspecao: 'Type',
		menuAGnInspecao: 'Nature',
		menuAGmInspecao: 'Model',
		menuAGgInspecao: 'Inspection Group',
		menuAGiInspecao: 'Inspection',
		menuAGaAeronave: 'of Aircrafts',
		menuAGnovaInspecao: 'New Inspection',
		menuAGeditarInspecao: 'Edit Inspection',
		menuAGdadosInspecao: 'Inspection data',
		menuAGmodelAeronave: 'Model',
		menuAGiDescricao: 'Description',
		menuAGnumPeca: 'Piece Number',
		menuAGnumSerie: 'Serie Number',
		menuAGvidaUtil: 'Inspection Life',
		menuAGiDias: 'Days',
		menuAGiMeses: 'Months',
		menuAGiAnos: 'Years',
		menuAGiHoras: 'Hours',
		menuAGhHomem: 'Hour/Man',
		menuAGcCiclo: 'Cicle',
		menuAGatualizado: 'Inspection updated successfully.',
		menuAGinserido: 'Inspection added successfully.',
		menuAGdescInspecao: 'Inspection description',
		menuAGtextoI1: 'Click on \'New Inspection\'',
		menuAGtextoI2: 'Click on icon',
		menuAGtextoI3: ' at list alongside.'
	},

	menuEscala: {
		tripulanteOperacional: 'Operational Crew',
		radioOperador: 'Radio operator',
		menuCarregaEscala: 'Loading scale',
		menuSalvaEscala: 'Saved',
		pilotos: 'Pilots',
		copilotos: 'Co-pilots',
		pilotoEcopiloto: 'Pilot and Copilot',
		sessaoManutencao: 'Maintenance Session',
		secaoManutencao: 'Maintenance Section',
		tripulanteArapiraca: 'Arapiraca Crewmember',
		tripulanteMaceio: 'Maceió Crewmember',
		menuRemover: 'Remove',
		menuEtotalDia: 'Total of services per day',
		menuElegenda: 'Label',
		menuElegenda1: 'Legend',
		menuEnovaLegenda: 'New Legend',
		menuEvermelho: 'Correct the fields in red.'
	},

	menuArapiraca: {
		menuAescala: 'Loading Arapiraca scale',
		menuAsalvo: 'Saved',
		menuAnpg: 'Name - Office/Grad'
	},

	menuMaceio: {
		menuMmaceio: 'Loading Maceió scale',
		menuMsalvo: 'Saved',
		menuMnpg: 'Name - Office/Grad',
		menuMtripulante: 'Crewmember already added.'
	},

	menuTripOperacional: {
		carregando: 'Loading operacional scale',
		escalaD: 'D - NORMAL',
		escalaS: 'S - ON WATCH',
		escalaE: 'E - EXPEDIENT'
	},

	menuOpRadio: {
		carregando: 'Loading radio operator scaler'
	},

	menuErro: {
		menuTextoErro: 'Happened something wrong when you tried to do this action.',
		menuTextoErro2: 'Something tell me that you can\'t do that.',
		menuEtitulo: 'Ops!',
		menuEtitulo2: 'Oh-ou!'
	},

	menuManutencao: {
		menuTipo: 'Type',
		menuNivel: 'Level',
		menuUltimaDataAtualizacao: 'Last update',
		menuMapu: 'APU',
		menuMtecnico: 'Maintenance technician',
		menuMtotal: 'Total',
		menuMapoio: 'Ground support',
		menuMctm: 'C T M',
		menuMf: 'F - VACATION',
		menuMx: 'X - IS SCALED',
		menuMeventos: 'Events',
		menuMdescricao: 'Description',
		menuMhHomemHora: 'Men/Hour',
		menuMdataPrevista: 'Expected Date',
		menuMdisponibilidade: 'Availability',
		menuMhorasTotais: 'Total Hours',
		menuMdetalhes: 'Update',
		menuMhorasAtuais: 'Current Hours',
		menuMrevalidaC: 'Revalidations and certifications',
		menuMinspReg: 'Regulamentary Inspections',
		menuMinspProg: 'Scheduled Inspections',
		menuMcontrolComp: 'Components Control',
		menuMinspProgEquip: 'Scheduled Equipment Inspections',
		menuMcelula: 'Airframe',
		menuMmotor: 'Powerplant',
		menuMmodelo: 'Model',
		menuMcodinome: 'Codename',
		menuMnumSerie: 'Nº Serie',
		menuMhrsAtuais: 'Current Hours',
		menuMpousosAtuais: 'Current Landings',
		menuMciclosNG: 'NG Cycles',
		menuMciclosT1: 'NF Cycles',
		menuMciclon1: 'N1 Cycles',
		menuMciclon2: 'N2 Cycles',
		menuMatualizaManutencao: 'Update Maintenance',
		menuMescolha: 'Chooice an option',
		menuMinspProgDE: 'Scheduled Inspections Of',
		menuMcontrolCompDE: 'Components Control Of',
		menuMatualizada: 'Maintenance updated successfully'
	},

	menuAGnovaEscala: {
		menuAGtipoEscala: 'Type',
		menuAGbusca: 'Search',
		menuAGcarregar: 'Load'
	},

	menuAGplanoManutencao: {
		menuAGInspecaoAtualizada: 'Updated inspections.',
		menuAGplano: 'Maintenance Plan',
		menuAGinspecao: 'Inspection',
		menuAGperiodicidade: 'Periodicity',
		menuAGpeca: 'Part',
		menuAGserie: 'Serie',
		menuAGdetalhes: 'Details',
		menuAGaddInspecao: 'Add Inspection to Plan',
		menuAGinspDetalhe: 'Inspection Details',
		menuAGcelula: 'Airframe',
		menuAGmotor: 'Motor',
		menuAGinspecoes: 'Inspections',
		menuAGaddTodas: 'Add All',
		menuAGremoveTodas: 'Remove All',
		menuAGmodelo: 'Model',
		manuAGNenhumaEncontrada: 'No Inspection Found.',
		revalidacoes: 'REVALIDATIONS AND CERTIFICATIONS',
		inspecoesRegulamentares: 'REGULATORY INSPECTIONS',
		inspecoesProgramadas: 'SCHEDULED AIRFRAME INSPECTIONS',
		controleDeComponentesCeula: 'CONTROL OF AIRFRAME COMPONENTS',
		comprimentoDeBoletins: 'COMPLIANCE WITH AIRWORTHINESS BULLETINS',
		boletins: 'Newsletters',
		comprimentodeBoletinsServico: 'COMPLIANCE WITH SERVICE BULLETINS',
		inspecoesProgramadasEquipamento: 'SCHEDULED EQUIPMENT INSPECTIONS',
		inspecoesProgramadasMotor: 'PROGRAMMED POWERPLANT INSPECTIONS',
		controleDeComponentesMotor: 'POWERPLANT COMPONENT CONTRACT',
		inspecoesAcessoriosMotor: 'PROGRAMMED POWERPLANT ACCESSORY INSPECTIONS'
	},

	menuAGprevencao: {
		menuAGNovaPrevencao: 'New Prevention',
		menuAGconclusao: 'Description of the conclusion',
		menuAGconcluir: 'Conclude prevention',
		menuAGdataOcorrencia: 'Occurrence date',
		menuAGlocal: 'Local of occurrence',
		menuAGcidade: 'City',
		menuAGcidade2: 'City',
		menuAGaeronave: 'Aircraft',
		menuAGaeronave2: 'Aircraft',
		menuAGenvolvidos: 'Staff involved',
		menuAGdescricao: 'Description',
		menuAGrelator: 'Reporter',
		menuAGemail: 'E-mail',
		menuAGpPrevencao: 'Prevention',
		menuAGrelatorioAdicionado: 'Report added successfully.',
		menuAGprevencaoConcluida: 'Prevention complete.',
		menuAGrelatoOcorrencia:
			'The report of the occurrence presented here has as sole purpose the incentive to operational safety, therefore, its use is exclusively for the prevention of accidents. NO NEED TO BE SIGNED OR IDENTIFIED',
		menuAGrelatorio: 'Preventive Reports',
		menuAGrelato: 'Preventive Reports'
	},

	menuAGcadAluno: {
		requisitosParaOcurso: 'Requirements for this course.',
		eulieaceitootermo: 'I have read and agree to the terms above.',
		paraPortadoresDeLicenca: 'For Licensees',
		inscricaoSalva: 'Registration saved successfully!',
		numeroInscricao: 'Registration Number',
		voltarParaLista: 'Back to list',
		sebrac: 'SEBRAC',
		menuAGalunoInscs: 'Registrations',
		menuAGalunoAdm: 'Administration',
		menuAGalunoEscolar: 'School',
		menuAGalunoNovaInsc: 'New Registration',
		menuAGalunoInsc: 'Registration',
		menuAGalunoDoc: 'Document',
		menuAGalunoFicha: 'Registration Form',
		menuAGalunoSexo: 'Gender',
		pilotoPPaviao: 'Private Airplane Pilot - Practical',
		pilotoPTaviao: 'Private Airplane Pilot - Theoretical',
		pilotoCPaviao: 'Commercial Airplane Pilot - Practical',
		pilotoCTaviao: 'Commercial Airplane Pilot - Theoretical',
		pilotoPPhelicoptero: 'Private Helicopter Pilot - Practical',
		pilotoPThelicoptero: 'Private Helicopter Pilot - Theoretical',
		pilotoCPhelicoptero: 'Commercial Helicopter Pilot - Practical',
		pilotoCThelicoptero: 'Commercial Helicopter Pilot - Theoretical',
		habIFRhelicopteroP: 'Helicopter IFR enablement - Practical',
		habIFRhelicopteroT: 'Helicopter IFR enablement - Theoretical',
		habIFRaviaoP: 'Airplane IFR enablement - Practical',
		habIFRaviaoT: 'Airplane IFR enablement - Theoretical',
		simuladorVoo: 'Flight Simulator',
		habilitacao: 'For Drivers',
		dadosPessoais: 'Personal Data',
		contato1: 'Home Phone',
		contato2: 'Cell phone',
		contato3: 'Contact 3',
		empresa: 'Company',
		nomeEmpresa: 'Company Name',
		menuAGalunoCargo: 'Office',
		filiacao: 'Filiation',
		nomeMae: 'Mother\'s Name',
		nomePai: 'Father\'s Name',
		documentacao: 'Documentation',

		docIdentidade: 'Identity',
		docOrgaoExpeditor: 'General registry entity',
		docDataExpedicao: 'Date of issue',
		docCic: 'Register',
		docCertidaoDeReservista: 'Certificate of Reservation',
		docCategoria: 'Category',
		docTituloEleitor: 'Election Title',
		docZona: 'Zone',
		doSecao: 'Section',

		doc1: 'Document 1',
		doc2: 'Document 2',
		doc3: 'Document 3',
		nivelInstrucao: 'Instruction Level',
		escolhaNivelInstrucao: 'Choose your instruction level',
		superiorCompleto: 'Graduated',
		ensinoFundamental: 'School',
		ensinoMedio: 'high school',
		mestrado: 'Master\'s degree',
		doutorado: 'Doctorate',
		curso: 'Course',
		idiomasEstrangeiros: 'Foreign Languages',
		idioma: 'Language',
		le: 'Read',
		escreve: 'Write',
		fala: 'Speak',
		entende: 'Understand',
		infoAdicionais: 'Additonal Information',
		tipoSanguineo: 'Blood Type',
		fatorRH: 'RH Factor',
		alergico: 'Are you allergic to any type(s) of medicine(s)? Describe it(s)',
		acidente: 'In case of an accident notify',
		grauParentesco: 'Degree of Kinship',
		outrasInfo: 'Other Information'
	},

	menuAGcadCurso: {
		cadCursoTitulo: 'Courses',
		cadCursoSecretaria: 'School of Flight',
		cadNovoCurso: 'New Course',
		cadEditarCurso: 'Edit Course',
		cadNomeCurso: 'Course Name',
		cadCursoPratico: 'Practical',
		cadCursoTeorico: 'Theoretical',
		cadCursoCargaHoraria: 'Workload',
		cadValorCurso: 'Course value',
		cadCursoDisciplina: 'Subjects',
		cadCursoNovaDisciplina: 'Add New Subject',
		cadCursoCliente: 'Click on \'New\'',
		cadCursoSucesso: 'Course Added',
		cadCursomenuMtexto2: 'Click on icon',
		cadCursomenuMtexto3: 'at list alongside',
		cadCursoAtualizado: 'Course updated'
	},

	menuCadPacote: {
		PacoteTitulo: 'Package',
		PacoteSecretaria: 'School of Flight',
		PacoteDescricao: 'Description',
		NovoPacote: 'New Package',
		EditarPacote: 'Edit Package',
		PacotePratico: 'Practical',
		PacoteTeorico: 'Theoretical',
		PacoteNumeroHoras: 'Workload',
		ValorPacote: 'Package Value ',
		PacoteCliente: 'Click on \'New\'',
		PacoteTexto1: 'Click on icon',
		PacoteTexto2: 'at list alongside.',
		PacoteSucesso: 'Package Added',
		PacoteAtualizado: 'Package updated'
	},

	menuCadHabilitacao: {
		HabiTitulo: 'License',
		HabiSecretaria: 'School of Flight',
		HabiDescricao: 'Description',
		NovoHabi: 'New License',
		EditarHabi: 'Edit License',
		HabiCliente: 'Click on \'New\'',
		HabiTexto1: 'Click on icon',
		HabiTexto2: 'at list alongside.',
		HabiSucesso: 'License Added',
		HabiAtualizado: 'License updated'
	},

	menuAGcadMatricula: {
		cadMatriculaTitulo: 'Registration',
		cadNovaMatricula: 'New Registration',
		cadNumero: 'Number',
		cadNomeAluno: 'New Student',
		cadCurso: 'Course',
		cadHabilitacao: 'License',
		attMatricula: 'Registration updated',
		addMatricula: 'Registration added',
		fechaMatricula: 'Registration ended'
	},

	menuAGcadPagamento: {
		cadPagamentoTitulo: 'Payment',
		cadNovoPagamento: 'New Payment',
		cursoHab: 'Course',
		nomeAluno: 'Name - Student',
		cadValor: 'Value',
		codigoPagamento: 'Code',
		addPagamento: 'Payment added',
		attPagamento: 'Payment updated',
		fechaPagamento: 'Payment ended'
	},

	menuAGpermutas: {
		menuAGsecretariaAlagoas: 'Secretary of State for Public Security of Alagoas',
		menuAGchefiaEspecial: 'Special Head of the Public Security Area',
		menuAGsalvo: 'Saved successfully!',
		menuAGcidade: 'City',
		menuAGestado: 'State',
		menuAGlocal: 'Local',
		menuAGdata: 'Date',
		menuAGenvolvidos: 'Involved',
		menuAGaeronave: 'Aircraft involved',
		menuAGsituacao: 'Situation',
		menuAGconclusao: 'Conclusion',
		menuAGnome: 'Name',
		menuAGemail: 'E-mail',
		menuAGtel: 'Telephone',
		menuAGtipo: 'Type',
		menuAGtipo2: 'Type',
		menuAGinicio: 'Start',
		menuAGfim: 'End',
		menuAGsolicitado: 'Requested',
		menuAGresposta: 'Answer',
		menuAGresposta2: 'Answer'
	},

	menuAGtipoAfastamento: {
		cadAfastamentoTitulo: 'Absence Type Register',
		menuAGcadAfastamento: 'New absence',
		menuAGdescAfastamento: 'Description',
		menuAGdescAfastamento2: 'Absence description',
		menuAGeditAfastamento: 'Edit Absence',
		menuAGtextoG1: 'Click on \'New\'',
		menuAGtextoG2: 'Click on icon',
		menuAGtextoG3: ' at list alogside.',
		menuAGattAfastamento: 'Absence updated',
		menuAGaddAfastamento: 'Absence added'
	},

	menuAGtipoMissao: {
		cadMissaoTitulo: 'Mission Type Register',
		menuAGcadMissao: 'New Mission',
		menuAGdescMissao: 'Description',
		menuAGdescMissao2: 'Mission description',
		menuAGeditMissao: 'Edit Mission',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside.',
		menuAGattMissao: 'Mission updated',
		menuAGaddMissao: 'Mission added'
	},

	menuAGtipoOcorrencia: {
		cadOcorrenciaTitulo: 'Occurrence Type Register',
		menuAGcadOcorrencia: 'New Occurrence',
		menuAGdescOcorrencia: 'Description',
		menuAGdescOcorrencia2: 'Occurrence description',
		menuAGeditOcorrencia: 'Edit Occurrence',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside',
		menuAGattOcorrencia: 'Occurrence updated',
		menuAGaddOcorrencia: 'Occurrence added'
	},

	menuAGtipoPrioridade: {
		cadPrioridadeTitulo: 'Priority Type Register',
		menuAGcadPrioridade: 'New Priority',
		menuAGdescPrioridade: 'Description',
		menuAGdescPrioridade2: 'Priority description',
		menuAGeditPrioridade: 'Edit Priority',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside',
		menuAGattPrioridade: 'Priority updated',
		menuAGaddPrioridade: 'Priority added'
	},

	menuAGtipoGuarnicao: {
		cadGuarnicaoTitulo: 'Garrison Type Register',
		menuAGcadGuarnicao: 'New Garrison',
		menuAGdescGuarnicao: 'Description',
		menuAGdescGuarnicao2: 'Garrison description',
		menuAGgSigla: 'Initials',
		menuAGgOrdem: 'Order',
		menuAGeditGuarnição: 'Edit Garrison',
		menuAGtextoG1: 'Click on \'New\'',
		menuAGtextoG2: 'Click on icon',
		menuAGtextoG3: ' at list alongside.',
		menuAGattGuarnicao: 'Garrison updated',
		menuAGaddGuarnicao: 'Garrison added'
	},

	menuAGtipoNatureza: {
		cadNaturezaTitulo: 'Nature Type Register',
		menuAGcadNatureza: 'New Nature',
		menuAGdescNatureza: 'Description',
		menuAGdescNatureza2: 'Nature description',
		menuAGnSigla: 'Initials',
		menuAGeditNatureza: 'Edit Nature',
		menuAGtexto1: 'Click on \'New\'',
		menuAGtexto2: 'Click on icon',
		menuAGtexto3: ' at list alongside.',
		menuAGattNatureza: 'Nature updated',
		menuAGaddNatureza: 'Nature added'
	},

	menuMoficina: {
		cadOficinaTitulo: 'Manufactory Register',
		menuMtexto1: 'Click on \'New Manufactory\'',
		menuMtexto2: 'Click on icon',
		menuMtexto3: ' at list alongside.',
		menuMcadOficina: 'Register Manufactory',
		menuMresponsavel: 'Responsible',
		menuMeditOficina: 'Edit Manufactory',
		menuMaddOficina: 'Manufactory added',
		menuMattOficina: 'Manufactory updated'
	},

	menuMsolicitaManutencao: {
		menuMsolicitaInspecoes: 'Inspections',
		menuMsolicitaEvento: 'Event',
		menuMsolicitaTipo: 'Type',
		menuMsolicitaModalidade: 'Modality',
		menuMsolicitaNivel: 'Level',
		menuMsolicitaHhora: 'Mens Hour',
		menuMsolicitaDisponibilidade: 'Availability',
		menuMsolicitaProxInspecao: 'Next Inspection',
		menuMsolicitaMesesDias: 'Months / Days',
		menuMsolicitaHtotais: 'Total Hours',
		menuMsolicitaEscolha: 'Choose the inspections below',
		menuMsolicitaSelecione: 'Select one or more inspections below and then click ADD',
		menuMsolicitaReferente: 'Requests for aircraft',
		menuMsolicitaCancelar: 'Do you want to cancel this Maintenance Request?',
		menuMsolicitaAdd: 'Maintenance Request Updated.',
		menuMsolicitaAtt: 'Maintenance Request Added.',
		menuMsolicitaManutencoes: 'Maintenance Requests'
	},

	menuAfastamento: {
		menuAaprovar: 'Approve',
		menuAreprovar: 'Disapprove',
		tipo: 'Type',
		menuAatualizado: 'Request updated successfully.',
		menuAadicionado: 'Request added successfully.'
	},

	menu: {
		sairSistema: 'Do you want to the exit the system?',
		administracao: 'General Administration',
		menuOrdem: 'Mission',
		menuMissao: 'Order',
		menuRastreamento: 'TRacking',
		menuMonitoraAeronaves: 'Aircrafts',
		menuManutencao: 'Maintenance',
		menuManutencaoAeronave: 'Aircraft',
		menuRelatorios: 'Reports',
		menuGerenciais: 'Management',
		menuAdministracao: 'Administration',
		menuGeral: 'General',
		menuTrello: 'Trello',
		menuProjeto: 'Projects',
		menuRastreador: 'Tracker',
		menuTrocarEquipamento: 'Change Equipment'
	},

	submenu: {
		curso: 'Course',
		disciplina: 'Major',
		ExtratoCompleto: 'Complete Extract',
		ControleAtividadeAerea: 'Air Activity Control',
		aeronaves: 'Aircrafts',
		gestaoDeEnsino: 'Teaching management',
		horasVoadas: 'Flight Hours',
		horasRastreadas: 'Tracked Hours',
		mostradores: 'Counters',
		telaCheia: 'Full Screen',
		relatorioVoo: 'Flight report',
		estatisticaVoo: 'Flight statistic',
		relatorioPrevencao: 'Preventive Reports',
		relatorioOperacoes: 'Operations Report',
		relatorioSolicitacoes: 'Requests Report',
		cadUser: 'User Register',
		cadEscala: 'Schedule',
		escala: 'Scale',
		escalas: 'Scale',
		gestaoEscalas: 'Scale Management',
		cadPrevencao: 'Prevention Register',
		permutas: 'Request Schedule Changes',
		subRelatorio: 'Reports',
		subSolicitacoes: 'Request',
		subRelatorioOrdem: 'Mission Report',
		subOrdem: 'Mission',
		cadCargo: 'Office Register',
		cadPosto: 'Post Register',
		cadastroGrupoInspecao: 'Inspection Group Registration',
		cadAcao: 'Register of Action Type',
		cadAfastamento: 'Register of Removal Type',
		subAdministracao: 'Administration',
		subEscolar: 'School',
		subEnsino: 'Teaching',
		subPagamentos: 'Payments',
		subTurmas: 'Classes',

		inscricoesEMatricula: 'Registration and Enrollment',
		gestaoDoEnsino: 'Teaching Management',
		teoricoEPratico: 'Theoretical and practical',
		cadEvento: 'Events Registration',
		segurancaOperacionalRac: 'Civil Aviation Report (RAC)',
		segurancaOperacionalEso: 'Risk management (ESO)',
		segurancaOperacionalRire: 'Initial Emergency Response Report (RIRE)'
	},

	componentNatureza: {
		cNatureza: 'Nature of Occurrence',
		cTipo: 'Type of Occurrence',
		cItem: 'No items added yet',
		cAddItem: 'You can add just one item',
		cItemAdicionado: 'item already added',
		cItemJaAdicionado: 'This item already was added'
	},

	componentRAisp: {
		risp: 'Risp',
		aisp: 'Aisp'
	},

	nomesMes: {
		janeiro: 'January',
		fevereiro: 'February',
		marco: 'March',
		abril: 'April',
		maio: 'May',
		junho: 'June',
		julho: 'July',
		agosto: 'August',
		setembro: 'September',
		outubro: 'October',
		novembro: 'November',
		dezembro: 'December'
	},

	diasSemana: {
		domingo: 'S',
		segunda: 'M',
		terca: 'T',
		quarta: 'W',
		quinta: 'T',
		sexta: 'F',
		sabado: 'S'
	},
	diasDaSemana: {
		domingo: 'Sun',
		segunda: 'Mon',
		terca: 'Tue',
		quarta: 'Wed',
		quinta: 'Thu',
		sexta: 'Fri',
		sabado: 'Sat'
	},

	diasSemanaPos: {
		0: 'S',
		1: 'M',
		2: 'T',
		3: 'W',
		4: 'T',
		5: 'F',
		6: 'S'
	},

	cadAeronave: {
		novaAeronave: 'New Aircraft',
		cadastroDeAeronave: 'Aircraft Register',
		dadosAeroanve: 'Aircraft Data',
		dadosMotor: 'Powerplant Data',
		aviao: 'Plane',
		helicoptero: 'Helicopter',
		prefixo: 'Prefix',
		tailNumber: 'Tail Number',
		modelo: 'Model',
		codinome: 'Codename',
		imei: 'IMEI',
		registro: 'Record',
		etiqueta: 'Label',
		horasVoadas: 'Hours Flown',
		ciclosVoados: 'Cycles Flown',
		dataFabricacao: 'Date of Manufacture',
		fabricante: 'Manufacturer',
		dataUltima: 'Date of Last Maintenance',
		pousos: 'Landings',
		serialNumber: 'Serial Number',
		ciclosT1: 'Cycles Flown NF',
		motor: 'Powerplant',
		modeloMotor: 'Powerplant Model',
		serialNumberMotor: 'Serial Number Motor',
		tipo: 'Type',
		msgAtualizada: 'Aircraft updated successfully.',
		msgInserida: 'Inspection added successfully.'
	},

	menuSistema: {
		usuarioSistema: 'User\'s System',
		suporteTecnico: 'Technical Support',
	},
	menuDiscrepancia: {
		discrepanciaCancelada: 'Discrepancy Canceled'
	},
	menuEdicaoDiario: {
		tempoDeVoo: 'Time of flight',
		horimetroFinal: 'Final Flight Hours',
		horimetroInicial: 'Initial Flight Hours',
		nenhumEmpenhoAdicionado: 'No Effort added',
		nenhumMotorAdicionado: 'No engine added'
	},
	menuOrgaoApoiados: {
		orgaoApoiados: 'Agency Supported',
		orgaosApoiados: 'Agencies Supported',
		orgaoCadastro: 'Agency Register',
		orgao: 'Agency'
	},
	menuConfiguracao: {
		sms: 'SMS Text',
		emailAssunto: 'E-mail Subject',
		emailTexto: 'E-mail Text',
		pessoasNotificadas: 'Notified People'
	},
	menuUsuarioANAC: {
		codigoAviacao: 'Aviation Agency Code'
	},
	menuAdicionarPerfil: {
		paraAdicionar: 'To add a profile',
		selecionePerfil: 'select the profile and click on ADD'
	},
	menuMalha: {
		novaSemana: 'Add Week'
	},
	menuSegurancaOperacional: {
		situacaoRelatada: 'Reported Situation',
		numeroDocumentoOrigem: 'Source Document No.',
		codigoControleInterno: 'Internal Control Code',
		dataDoOcorrido: 'Date of occurrence',
		horaDoOcorrido: 'Time of occurrence',
		localDoOcorrido: 'Place of occurrence',
		organizacoesEnvolvidas: 'Organizations Involved',
		descricaoEvento: 'Description of the event',
		analiseInicial: 'Initial Analysis',
		probabilidade: 'Probability that ESO will reoccur',
		severidade: 'Severity if the worst possible consequence of this event occurs',
		setoresResponsaveis: 'Sectors responsible for mitigation',
		tolerabilidade: 'Tolerability',
		respostaEnviadaAoRelator: 'Response sent to the rapporteur?',
		analiseEvento: 'Event Analysis',
		acaoesMitigadoras: 'Mitigating Actions',
		fatoresContribuintes: 'Contributing Factors',
		acoesForamSuficienteFinal: 'Were mitigating actions sufficient?',
		motivosAcoesNaoSuficiente: 'Reasons for non-sufficiency',
		quaisAcoesAdicionaisAdotadas: 'What additional actions should be taken?',
		eventoOperacionalRelatadoAspectos: 'The reported operational safety event (ESO) involves one of the following aspects',
		remetente: 'Sender\'s name',
		enviadaEm: 'Response sent to the Rapporteur on',
		codigoOACI: 'OACI Code',
		executivo: 'Executive',
		questionarioGestorSegurancaOperacional: 'About the Operational Safety Manager',
		informante: 'Who reported',
		tipoSituacao: 'Situation Type',
		condicoesPRE: 'Conditions under which <PRE> <PLEM> has been activated',
		existiaExemplar: 'Was there a <PRE> <PLEM> copy?',
		exemplarAtualizado: 'Copy <PRE> <PLEM> was updated?',
		comoFoiAcionado: 'How it was triggered',
		informacoesAtenderam: 'Did information meet the needs?',
		deficienciasIdentificadas: 'Deficiencies found in the information',
		acionadoOrgaosExternos: 'Has the external organs that are part of <PRE-XXX> and / or <PLEM-SXXX> activated?',
		orgaosEnvolvidos: 'External bodies involved',
		houveDerramamentoCombustivel: 'Was fuel or oil spilled on the runway or location?',
		pistaInterditada: 'Was the runway blocked?',
		tempoPistaInterditada: 'Track time blocked',
		paralisacaoOperacoes: 'Did the operations stop?',
		tempoRetomadaOperacoes: 'Time when operations returned to normal',
		recursosDisponiveisForamAdequados:
			'Were the resources available in <PRE-XXX> and / or <PLEM-SXXX> adequate and sufficient for the dismantling of the track?',
		deficienciasPorFaltaRecursos: 'Deficiencies identified',
		evacuacaoTripulantes: 'Description of evacuation of crew / passengers',
		disponibilizacaoAcomodacoes: 'Has accommodation been made available to family members and the public in general?',
		outrasInformacoes: 'Other information',
		cliente: 'Customer',
		analiseFinal: 'Final Analises',
	},
	cores: {
		azul: 'Blue',
		verde: 'Green',
		cinza: 'Grey',
		preto: 'Black',
		vermelho: 'Red',
		amarelo: 'Yellow'
	}
}
